export const JEDI_HR_URL = process.env.REACT_APP_URL_JEDI_HR_URL;
export const genders = ["Male", "Female", "Transgender"];
export const nationality = [
  "Afghan",
  "Arubian",
  "N.A",
  "Christmas Islander",
  "Indonesian",
  "Indian",
];
export const bloodGroups = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];

export const maritalStatus = [
  "Widowed",
  "Married",
  "Separated",
  "Divorced",
  "Single",
  "Not Disclosed",
];
export const employeeStatus = [
  { key: "Inactive", value: "I" },
  { key: "Active", value: "A" },
];
export const confirmationStatus = ["Confirmed", "Probation"];
export const employeeType = [
  "Retainer",
  "Intern",
  "Onroll FE Non SMT",
  "Apprentice",
  "Offroll Commissary",
  "Offroll F&V DC",
  "Promoter",
  "Offroll Dry DC",
  "Offroll CC",
  "Offroll RPC",
  "Consultants",
  "Onroll BE",
  "Onroll Margin",
  "Onroll FE SMT",
  "Vendor",
  "Offroll BE",
  "Offroll FE",
];
export const employeeSubType = [
  "Retainer",
  "Intern",
  "Apprentice",
  "Offroll Commissary",
  "Onroll BE-ESIC",
  "Onroll FE Non SMT-ESIC",
  "Onroll FE SMT-ESIC",
  "Offroll Dry DC",
  "Onroll FE Non SMT-Non ESIC",
  "Offroll RPC",
  "Vendor",
  "Offroll FE",
  "Onroll BE-Non ESIC",
  "Offroll F&V DC",
  "Promoter",
  "Onroll Margin-Non ESIC",
  "Offroll CC",
  "Consultants",
  "Promoters",
  "Offroll BE",
  "Onroll Margin-ESIC",
  "Onroll FE SMT-Non ESIC",
];
export const jobBand = [
  "15-PR",
  "10",
  "CNT",
  "7",
  "DC_Off Roll",
  "17",
  "5",
  "TR",
  "INT",
  "11B",
  "3",
  "6",
  "2",
  "11",
  "JB 15-OR",
  "16",
  "ST",
  "1",
  "4",
  "9",
  "8",
];
export const jobGrade = [
  "CNT",
  "JB11B",
  "JB9",
  "JB11",
  "JB7",
  "DC_Off Roll",
  "TR",
  "INT",
  "JB 15-PR",
  "JB 17",
  "JB5",
  "JB3",
  "JB2",
  "JB 16",
  "JB 15-OR",
  "ST",
  "JB10",
  "JB8",
  "JB1",
  "JB6",
  "JB4",
];
export const designationNameAndCode = [
  "Ecom Picker Off Roll HM (DES_587)",
  "Head - Repairs, Maintenance and Projects (DES_889)",
  "Fixed Asset -2 (BEOR0046)",
  "Category Manager (DES_551)",
  "1013227-SM Shad Nagar-HK (1013227-SM Shad Nagar-HK)",
  "F&V MIS - Hubli (BEOR0026_1)",
  "IT Associate - DL 5 (BEOR0076)",
  "R&M Electrician - East 1 (BEOR0122)",
  "Manager NSO (DES_738)",
  "Store Technician SKN (Mangalore & UC) (BEOR0138)",
  "Secretary (DES_892)",
  "HR Vendor (DES_909)",
  "Merchandising Head (DES_33)",
  "Senior Payroll & Compliance Manager (DES_925)",
  "Matrix Vendor (DES_908)",
  "Stores LP VO SKN (BEOR0140)",
  "Grader F&V DC (DES_488)",
  "Cluster Manager - Dark Stores (DES_967)",
  "TA & Onboarding Coordinator (BEOR0133)",
  "Team Member - Procurement (DES_84)",
  "CSA Full Time (DES_134)",
  "Picker F&V DC (DES_496)",
  "R&M Electrician - HYD 1 (BEOR0010)",
  "Managing Director (DES_411)",
  "Maintenance Supervisor (DES_251)",
  "Head of Growth & Strategy (DES_1004)",
  "DC Technician SKN (BEOR0023)",
  "Picker Part Time - Offroll - HM (DES_697)",
  "Packer CC_Onroll (DES_1071)",
  "IT Associate - CH 4 (BEOR0080)",
  "National Transportation Manager (DES_252)",
  "Regional F&V DC Manager (DES_743)",
  "F&V DC Manager (DES_235)",
  "RPC Production Incharge (DES_289)",
  "National Buyer Pulses (DES_293)",
  "F&V MIS - SKN (BEOR0027_1)",
  "Quality CC (DES_522)",
  "Inventory Supervisor (DES_246)",
  "Circle Head - B2B Sales (DES_777)",
  "Security HM (DES_586)",
  "Circle Omni Lead (DES_694)",
  "Circle HR Head (DES_739)",
  "Fixed Asset -1 (BEOR0045)",
  "National Sourcing & Regional F&V Sourcing Head (DES_795)",
  "Divisional Head (DES_131)",
  "IT Associate - KL (BEOR0067)",
  "Trainee Area Manager- Supermarket (DES_903)",
  "Activation Manager (99894)",
  "Senior Lead-Legal & Compliance (DES_165)",
  "Support F&V DC (DES_508)",
  "Loader Dry DC (DES_492)",
  "Head - Business Development (DES_774)",
  "Head - Legal & Compliance (DES_159)",
  "Promoters Employees (161147)",
  "R&M Technician - STP Operator (DES_882)",
  "IT Associate - HO 6 (BEOR0100)",
  "Talent & Org. Partner - Human Resources (DES_1030)",
  "Chief Technology & Product Officer (DES_1028)",
  "Fusion Support (DES_852)",
  "Housekeeper Part Time Offroll SM (DES_787)",
  "5113425-HM Sector 37 Gurgaon -CSA (5113425-HM Sector 37 Gurgaon -CSA)",
  "Promoter SM (DES_888)",
  "Program Manager - Growth Initiatives (DES_825)",
  "Admin Executive (DES_799)",
  "8503775-HM Jharsuguda, Odisha-CSA-Full Time (8503775-HM Jharsuguda, Odisha-CSA-Full Time)",
  "President and CFO (DES_856)",
  "Housekeeping Associate Off Roll SM (DES_591)",
  "Program Manager - Business Excellence (DES_816)",
  "Security SM (DES_585)",
  "Team Member - Property Accounting (DES_85)",
  "Bill passing - SKN 3 (BEOR0040)",
  "IT Associate - HYD 2 (BEOR0059)",
  "Housekeeping Associate RPC (DES_528)",
  "Scanner - SKN (BEOR0037)",
  "1153792-SM Nuzvid, Vijayawada-CSA_PT (1153792-SM Nuzvid, Vijayawada-CSA_PT)",
  "Margin (BEOR0051)",
  "Area Manager Supermarkets (DES_628)",
  "IT Associate - MH 1 (BEOR0101)",
  "Product Designer Intern (DES_664)",
  "Store Omni Lead (DES_193)",
  "Product Designer (DES_567)",
  "Loader CC_Onroll (DES_1070)",
  "Head Finance & Accounts - Vendor (DES_1092)",
  "1500102 - Bannerghatta Bangalore Circle Office - ASC100 (BEOR0149)",
  "Bangalore Technician SKN - 3 (BEOR0018)",
  "Dummy Designation (DummyPOS_01)",
  "F&V DC Logistics Incharge (DES_1089)",
  "RPC Head (DES_282)",
  "6513668-HM Galaxy-CSA-Full Time (6513668-HM Galaxy-CSA-Full Time)",
  "Inbound Incharge (DES_242)",
  "TM-Margin Management (DES_914)",
  "Checker Dry DC (DES_484)",
  "Talent Sourcing Lead (DES_740)",
  "Stacker Operator Lifestyle DC (DES_583)",
  "Team Member - HR Operations (DES_926)",
  "Apprentice_More Cafe Full Time (DES_1096)",
  "IT Associate - HYD 4 (BEOR0061)",
  "Lead - Talent Management (DES_1059)",
  "Mover Dry DC (DES_483)",
  "IT Support Engineer - Off roll (BEOR0154)",
  "Picker Full Time - Offroll - Dark Store (DES_945)",
  "TL-Reconciliation (Matrix) (DES_913)",
  "Assistant Category Manager (DES_862)",
  "Chief of Staff - CEO s Office (DES_824)",
  "Lead - Supply Chain Finance (DES_69)",
  "Lead - Store Excellence (DES_994)",
  "Executive Director (DES_855)",
  "Regional Buyer Staples (DES_294)",
  "CC Cluster Head (DES_265)",
  "Payroll (BEOR0047)",
  "Team Member - DC Operations (DES_646)",
  "Regional Operations Head (DES_329)",
  "Inbound Incharge (DES_563)",
  "Business Analyst - Store Excellence (DES_1018)",
  "Outbound Supervisor (DES_254)",
  "Program Lead – Growth and Strategy (DES_1022)",
  "Data Entry Operator - HYD 2 (BEOR0020_1)",
  "Head - Infrastructure and Networks (DES_144)",
  "Lead - Financial Accounting (DES_849)",
  "Housekeeping Associate Off Roll HM (DES_590)",
  "TM - FMCG+Staples+SF (BEOR0134)",
  "Duty Manager (DES_180)",
  "R&M Technician - East 2 (BEOR0130)",
  "Procurement (BEOR0049)",
  "Head - Store Excellence (DES_993)",
  "RPC Incharge (DES_285)",
  "Circle Category Head (DES_861)",
  "Area Manager (F&B Vertical) (DES_1007)",
  "Loading Supervisor (DES_248)",
  "Picker RPC (DES_525)",
  "Data Entry Operator - HYD 1 (BEOR0019_1)",
  "1013456-HM Nagole, Hyderabad -CSA (1013456-HM Nagole, Hyderabad -CSA)",
  "Sr. Product Manager (DES_429)",
  "Category Manager (DES_24)",
  "Vendor (DES_1088)",
  "Scanner Dry DC (DES_500)",
  "1503344-SM Tumkur 2-Apprentice_PT (1503344-SM Tumkur 2-Apprentice_PT)",
  "Picker Full Time - Offroll - SM (DES_700)",
  "Circle B2B Support (DES_776)",
  "Lead - Payroll Operations (DES_1048)",
  "Merchandising Head (DES_35)",
  "Inbound Call Agent – Multilingual Support (DES_1024)",
  "Executive level - Vendor (DES_1084)",
  "Lead - HR Shared Services (DES_622)",
  "RPC Outbound Incharge (DES_288)",
  "Happay Vendor (DES_918)",
  "Manager - Process & Implementation (DES_988)",
  "1523494-SM Bendre Nagar-Apprentice (1523494-SM Bendre Nagar-Apprentice)",
  "Lead - Shopper Marketing, Space Planning & Shared Services Centre (DES_842)",
  "Inventory Auditor (DES_923)",
  "Neosoft Vendor (DES_895)",
  "LP MIS SKN -2 (BEOR0106)",
  "Payroll Executive (BEOR0155)",
  "Support Dry DC (DES_507)",
  "Product Support Associate (DES_983)",
  "1711998-SM Mulgundnaka, Gadag-Apprentice_PT (1711998-SM Mulgundnaka, Gadag-Apprentice_PT)",
  "Picking Supervisor (DES_255)",
  "QA Incharge (DES_226)",
  "1501142-SM J P Nagar II, Bangalore-Apprentice_PT (1501142-SM J P Nagar II, Bangalore-Apprentice_PT)",
  "Statutory Auditor (DES_858)",
  "Off roll Associate - Margin (BEOR0053)",
  "Business Analyst (DES_307)",
  "Security - Dark Store (DES_943)",
  "Regional Buyer (DES_807)",
  "R&M Technician (DES_327)",
  "CSA_Apprentice Full Time (DES_1032)",
  "Junior Business Analyst (DES_974)",
  "R&M Electrician - HYD 2 (BEOR0011)",
  "Team Member - Compliance (DES_166)",
  "Associate - IT (DES_142)",
  "Mover F&V DC (DES_494)",
  "CEO - Retail (DES_562)",
  "Chief Operating Officer (DES_965)",
  "Lead - Procurement (DES_789)",
  "R&M Technician - East 1 (BEOR0129)",
  "Unloader CC_Onroll (DES_1073)",
  "RPC Inbound and Inventory Incharge (DES_283)",
  "Project Executive (DES_957)",
  "LP VO Stores SKN -1 (BEOR0109)",
  "Field Officer (DES_270)",
  "Office Admin SKN (BEOR0114)",
  "IT Store Support - TN (2) (BEOR0091_IT)",
  "IT Associate - SKN 6 (BEOR0088)",
  "Team Member - Taxation (DES_87)",
  "Head of Retail Learning (DES_672)",
  "Sourcing Manager - Basmati, Raw and Boiled Rice (DES_296)",
  "CRM - Omni Lead (DES_1060)",
  "Retail Learning Specialist (DES_794)",
  "Assistant Company Secretary (DES_616)",
  "Team Member - APMC (DES_927)",
  "Team Member - Supply Chain Finance (DES_86)",
  "SDE Intern (DES_1077)",
  "Payroll Specialist and CLM Compliance (DES_979)",
  "F&V DC Checker (DES_233)",
  "CSA Full Time (DES_935)",
  "Picker Full Time (DES_191)",
  "Program Manager - Insights and Analytics Omni (DES_968)",
  "PO Resource HO (BEOR0117)",
  "Inventory Incharge (DES_245)",
  "TM-Margin Management (Matrix) (DES_914)",
  "Program Lead - Growth and Strategy (DES_996)",
  "CSA Part Time (DES_183)",
  "Regional F&V Sourcing Head (DES_276)",
  "Account Executive (DES_629)",
  "Regional Office Supervisor SKN (BEOR0131)",
  "F&V DC Shift Incharge (DES_237)",
  "1500102 - Bannerghatta Bangalore Circle Office - ASC103 (BEOR0150)",
  "Grader CC_Onroll (DES_1069)",
  "Security F&V DC (DES_502)",
  "Rider & Picker Full Time (DES_939)",
  "Sourcing Manager (DES_280)",
  "Vendor (DES_853)",
  "Support RPC (DES_523)",
  "Tech Support (DES_865)",
  "Category Head (DES_18)",
  "Visual Design Intern (DES_904)",
  "IT Associate - SKN 3 (BEOR0070)",
  "SM Baggage Handlers - Off Roll (DES_482)",
  "Circle BD Lead - Dark Stores (DES_962)",
  "Program Lead - Omni Growth (DES_1011)",
  "Picker Full Time (DES_934)",
  "Inplant Supervisor (DES_638)",
  "IT ZO/Store Support - WB (2) (BEOR0086_IT)",
  "Picker_Apprentice Full Time (DES_1031)",
  "Omni Operations Lead (DES_822)",
  "Lead Compliance Officer (DES_919)",
  "Associate Product Designer (DES_829)",
  "Machine Operator RPC (DES_529)",
  "R&M Electrician HYD (BEOR0121)",
  "DC Manager (DES_230)",
  "Team Member - Infrastructure and network (DES_156)",
  "Apprentice Full Time (DES_184)",
  "Regional Lead - Infrastructure and network (DES_154)",
  "Picker Part Time (DES_192)",
  "Team Leader (DES_931)",
  "Store Technician MH (BEOR0136)",
  "Housekeeper Full Time - Offroll - Dark Store (DES_946)",
  "Bill passing - SKN 2 (BEOR0038)",
  "20024-Skyline Icon-HO (20024-Skyline Icon-HO-BEOR0163)",
  "IT Associate - East 4 (BEOR0086)",
  "Inbound Supervisor (DES_243)",
  "Regional Manager - Dark Stores (DES_1086)",
  "Head - Financial Accounting & Reporting (DES_840)",
  "Bill passing DSD- SKN (BEOR0039)",
  "Logistics Supervisor (DES_250)",
  "Stores Technician NKN 1 (BEOR0141)",
  "IT Associate - DL 3 (BEOR0074)",
  "Rider & Picker Full Time (DES_611)",
  "Security Full Time (DES_140)",
  "Electrician Dry DC (DES_1039)",
  "Secretary (DES_978)",
  "Promoter - Luggage (DES_1001)",
  "Area Operations Manager (DES_194)",
  "Vendor (DES_1068)",
  "CSA Full Time (DES_182)",
  "Housekeeper Full Time (DES_139)",
  "NSO AM (DES_1081)",
  "Business Analyst - CEO s Office (DES_917)",
  "5521606-SM Urban Estate, Patiala-CSA (5521606-SM Urban Estate, Patiala-CSA)",
  "IT Associate - HO 2 (BEOR0096)",
  "Store Incharge (DES_179)",
  "ORM Associate (DES_1023)",
  "Associate Director of Product and Engineering (DES_1012)",
  "Head of Dark Store Operations (DES_977)",
  "Payroll & Compliance Manager (DES_1080)",
  "Housekeeping Supervisor (DES_241)",
  "Store Manager - Dark Store (DES_930)",
  "Baggage Handler Full Time (DES_188)",
  "CSA_More Cafe Part Time (DES_1095)",
  "20024-Skyline Icon-HO (20024-Skyline Icon-HO-BEOR0162)",
  "Regional DC Manager (DES_257)",
  "Rewards Manager (DES_790)",
  "IT Associate - HO 1 (BEOR0095)",
  "Quality Assurance Tester (DES_954)",
  "Head Total Rewards, Payroll and HR Shared Services (DES_793)",
  "Inventory Controller (DES_915)",
  "Program Manager - Store Excellence (DES_995)",
  "Customer Excellence Lead (DES_781)",
  "IT Associate - CH 1 (BEOR0077)",
  "Packer RPC (DES_1036)",
  "Team Member - Fixed Asset (DES_78)",
  "CC incharge (DES_266)",
  "Vigilance Officer - HYD 1 (BEOR0012)",
  "Security Lead - DC Operations (DES_749)",
  "Chat Support Agent – Customer Escalations & Callbacks (DES_1025)",
  "Loader CC (DES_517)",
  "Head - Talent & Corporate Business Partnering (DES_1034)",
  "Customer Service Associate (DES_987)",
  "Payable (BEOR0048)",
  "B&M SSC Lead (DES_552)",
  "Payroll Support 1 (BEOR0115)",
  "Sourcing Heads Commodity (DES_295)",
  "Security Supervisor RPC (DES_1047)",
  "Ecom Picker Off Roll Dark Store (DES_952)",
  "Logistics Incharge (DES_249)",
  "NSO Support KN (BEOR0113)",
  "mymore HR Services (DES_571)",
  "LP Support (DES_1050)",
  "IT Associate - MH (BEOR0057)",
  "F&V Outbound Incharge (DES_238)",
  "NPD Incharge (DES_275)",
  "Outbound Incharge (DES_253)",
  "Lead - Infrastructure (DES_890)",
  "1703558-SM Bajpe-Mangalore-Apprentice (1703558-SM Bajpe-Mangalore-Apprentice)",
  "Supervisor Dry DC (DES_505)",
  "Picker Part Time (DES_933)",
  "Purchase Support (DES_880)",
  "Data Entry Operator F&V DC (DES_487)",
  "8503816-HM Balasore, Odisha-CSA-Full Time (8503816-HM Balasore, Odisha-CSA-Full Time)",
  "Chief Operating Officer (DES_985)",
  "RPC and LDC VO SKN (BEOR0132)",
  "Checker F&V DC (DES_485)",
  "Loss Prevention Officer (DES_814)",
  "Security Dry DC (DES_501)",
  "Unloader Fulltime - Onroll - Darkstores (DES_1016)",
  "Instore Lead (DES_1027)",
  "Quality Inspector F&V DC (DES_1042)",
  "Rider & Picker Part Time (DES_682)",
  "R&M Tech - CH 1 (BEOR0125)",
  "TM - Reimbursement (DES_1057)",
  "Manager - B&M & Amazon receivables (DES_1019)",
  "Retail Associate - Supermarkets (DES_637)",
  "IT Associate - SKN 4 (BEOR0084)",
  "Housekeeping Associate Lifestyle DC (DES_577)",
  "Supervisor CC (DES_519)",
  "R&M Electrician - East 2 (BEOR0123)",
  "1372039-SM Venkata Nagar, Kakinada-CSA (1372039-SM Venkata Nagar, Kakinada-CSA)",
  "Product Manager (DES_152)",
  "Team Member - IPR & Vendor management (DES_168)",
  "Assistant Category Manager (DES_1076)",
  "Support Engineer (DES_976)",
  "Marketing Finance Support (DES_997)",
  "TM Treasury(A) (50987)",
  "1703511-SM Kushal Nagar-Apprentice_PT (1703511-SM Kushal Nagar-Apprentice_PT)",
  "Team Member-Corporate Legal (DES_167)",
  "RPC Maintenance Incharge (DES_729)",
  "Supervisor CC_Onroll (DES_1072)",
  "Rider & Picker Full Time (DES_610)",
  "Stores Technician (DES_557)",
  "LP MIS SKN -1 (BEOR0105)",
  "Technical Lead (DES_158)",
  "CSA_More Cafe Full Time (DES_1094)",
  "Quality & Safety Head (DES_746)",
  "Picker Full Time - Offroll - HM (DES_696)",
  "Data Entry Operator Lifestyle DC (DES_575)",
  "Lead - Investor Relations (DES_1005)",
  "IT Associate - East 2 (BEOR0081)",
  "Team Member - IT (DES_157)",
  "Marketing Vendor (DES_990)",
  "B2B Sales Lead (DES_832)",
  "Vendor Manager - OB (DES_47)",
  "Project Manager (DES_879)",
  "Talent Acquisition Partner (DES_398)",
  "Lead - NSO (DES_956)",
  "CSA Offroll Full Time (DES_961)",
  "DC Projects Support (BEOR0022)",
  "Team Member - GL (DES_80)",
  "IT Associate - SKN 2 (BEOR0069)",
  "F&V Pack House Supervisor (DES_1091)",
  "Security Lifestyle DC (DES_582)",
  "CSA Offroll Full Time (DES_966)",
  "Logistics Supervisor (BEOR0019)",
  "Picker Part Time (DES_460)",
  "SSA-Amazon Full Time (DES_986)",
  "Customer Support Agent - Marketing (DES_1051)",
  "IT Associate - HYD 3 (BEOR0060)",
  "Picker Dry DC (DES_495)",
  "Housekeeper Full Time (DES_186)",
  "Supervisor (DES_615)",
  "Stores Technician NKN 2 (BEOR0142)",
  "Category Manager F&V (DES_1008)",
  "IT Associate - SKN 1 (BEOR0068)",
  "Head - Marketing (DES_893)",
  "Category Executive (DES_1054)",
  "Team Member - B&M SSC (DES_553)",
  "Demand Fulfillment Lead (DES_765)",
  "Baggage Handler Part Time (DES_189)",
  "Program Manager - Store Design (DES_921)",
  "Financial Accounting Manager (DES_850)",
  "20024-Skyline Icon-HO (20024-Skyline Icon-HO-BEOR0161)",
  "Store Manager (DES_130)",
  "R&M Technician (DES_881)",
  "Data Entry Operator Dry DC (DES_486)",
  "Stacker Operator Dry DC (DES_504)",
  "Vendor- Accounting Consultants (DES_1075)",
  "Circle BD Lead (DES_733)",
  "Circle Project Lead (DES_989)",
  "Housekeeping Associate Dry DC (DES_490)",
  "Picker Lifestyle DC (DES_579)",
  "CSA Offroll Part Time (DES_960)",
  "Grader CC (DES_515)",
  "IT Associate - DL 4 (BEOR0075)",
  "F&V Night shift VO SKN (BEOR0028)",
  "Team Member - Margin Management (DES_82)",
  "Creche Supervisor (DES_1078)",
  "Loader F&V DC (DES_493)",
  "IT Associate - HO 3 (BEOR0097)",
  "1021087-SM Circuit Road, Hyderabad-CSA (1021087-SM Circuit Road, Hyderabad-CSA)",
  "Apprentice Part Time (DES_185)",
  "TM HR Compliance (DES_625)",
  "Merchandising Space Planner - Apparel (BEOR0153)",
  "Category Executive - Frozen and Bakery Goods (DES_1017)",
  "Logistics Supervisor (DES_768)",
  "TL-Reconciliation (DES_913)",
  "F&V Quality Checker - East (BEOR0029_1)",
  "OPEX PO & GRN Executive (DES_1074)",
  "HRMS Controller and Rewards Support (DES_359)",
  "Apprentice Full Time (DES_941)",
  "Inventory Auditor (DES_896)",
  "8003670-Berhampore-POC-E Com (8003670-Berhampore-POC-E Com)",
  "Lead - Design (DES_863)",
  "DC Shift Incharge (DES_232)",
  "Area Operations Manager - Dark Stores (DES_929)",
  "HM Operations Support (DES_609)",
  "Product Intern (DES_430)",
  "Regional Compliance Officer (DES_916)",
  "Circle Director (DES_310)",
  "Email Support Agent – Customer Escalations (DES_1026)",
  "R&M - EUP (BEOR0120)",
  "8053064-SM Durgapur, Kolkata-Apprentice (8053064-SM Durgapur, Kolkata-Apprentice)",
  "Packer F&V DC (DES_1090)",
  "DSD -1 (BEOR0024)",
  "Buyer - North Indian Spices and Dry Fruits (DES_291)",
  "Data Entry Operator RPC (DES_530)",
  "5593311-SM Guru Govind Singh Jalandhar-Apprentice (5593311-SM Guru Govind Singh Jalandhar-Apprentice)",
  "Brand Manager (DES_887)",
  "SDE II (DES_470)",
  "Store Omni Lead (DES_133)",
  "R&M Tech - NCR (BEOR0124)",
  "Associate Visual Designer (DES_830)",
  "Chief of Staff - CFO s Office (DES_1006)",
  "TM Payroll & MIS (DES_408)",
  "Bill passing DSD - HYD 2 (BEOR0033)",
  "City Operations Lead (Omni) (DES_695)",
  "Regional Sourcing Manager SFME (DES_667)",
  "Housekeeper Full Time (DES_937)",
  "QA Incharge_F&V (DES_912)",
  "Head - Supply Chain Operations (DES_463)",
  "Picker Full Time (DES_137)",
  "CSA Offroll Part Time (DES_970)",
  "Team Member- Legal & Compliance (DES_170)",
  "Vigilance Officer - HYD 2 (BEOR0013)",
  "IT Associate - DL 1 (BEOR0072)",
  "R&M Tech - CH 2 (BEOR0126)",
  "MIS Project KN (BEOR0112)",
  "IT Store Support TN C (161407)",
  "8003249-SM Chakdah-Apprentice (8003249-SM Chakdah-Apprentice)",
  "Indirect Tax (BEOR0055)",
  "Projects Support (BEOR0118)",
  "IT Associate - DL 2 (BEOR0073)",
  "MIS - Vigilance Officer HYD (BEOR0111)",
  "Security Supervisor Dry DC (DES_1044)",
  "IT Associate - KL 1 (BEOR0082)",
  "SSA-Amazon Full Time (DES_839)",
  "Team Member - Format Commercial (DES_79)",
  "Scanner -SKN 1 (BEOR0041)",
  "Receiver F&V DC (DES_499)",
  "Housekeeper Part Time (DES_187)",
  "DC HR Lead (DES_1064)",
  "Associate Product Manager (DES_436)",
  "8003670-Berhampore-Apprentice (8003670-Berhampore-Apprentice)",
  "Creative Content Strategist (DES_964)",
  "Bill passing DSD - HYD 1 (BEOR0032)",
  "Vigilance Officer HYD (BEOR0143)",
  "Category Manager - Seafood & Meats (DES_972)",
  "Sourcing Manager - Flours, Dry Fruits and Spices (DES_297)",
  "BD Executive (DES_737)",
  "SDE III (DES_474)",
  "Fixed Asset (BEOR0050)",
  "Section Head - Space Planning (DES_40)",
  "Category Manager (DES_730)",
  "HR Operations and Communications Partner (DES_1067)",
  "Associate Visual Designer - Marketing (DES_975)",
  "Lead - Property Accounting (DES_68)",
  "TM Facilities (DES_402)",
  "CSA Offroll Full Time (DES_969)",
  "Store Technician SKN (Mysore & UC) (BEOR0139)",
  "LP VO Stores SKN -2 (BEOR0110)",
  "F&V DC Quality Incharge (DES_766)",
  "Team Member - HR SSC (DES_570)",
  "Chief Human Resources Officer (DES_334)",
  "Head - Category Buying, Pricing and Merchandising (DES_687)",
  "Housekeeping Associate F&V DC (DES_489)",
  "Head - Omni (DES_828)",
  "Team Member - Space Planning (DES_46)",
  "Talent Sourcing Specialist (DES_922)",
  "Lead - Payroll and Compliance (DES_818)",
  "Lead - Frontline Activation (DES_656)",
  "Store Unloader Dark Store (DES_948)",
  "IT Store Support - SKN (5) (BEOR0070_IT)",
  "F&V DC incharge (DES_234)",
  "Security RPC (DES_527)",
  "1503184-Old Airport Road-Housekeeper-Full Time (1503184-Old Airport Road-Housekeeper-Full Time)",
  "Retail Learning Manager (DES_1061)",
  "1713863-SM Hospet-Bellary Road-Apprentice_PT (1713863-SM Hospet-Bellary Road-Apprentice_PT)",
  "Packer F&V DC (DES_1037)",
  "Lead - Accounts Payable (DES_59)",
  "Circle Marketing Head (DES_805)",
  "Category Manager (DES_984)",
  "BD Manager (DES_736)",
  "Inventory Assistant (DES_244)",
  "Bangalore Technician SKN - 1 (BEOR0016)",
  "Team Leader (DES_132)",
  "CSA Part Time (DES_135)",
  "CC Supervisor (DES_267)",
  "Supervisor F&V DC (DES_506)",
  "RAP - Apprentice (DES_1066)",
  "Apprentice Full Time (DES_136)",
  "Lead-Legal & Compliance (DES_160)",
  "IT Associate - CH 3 (BEOR0079)",
  "F&V Category Head (DES_1000)",
  "Talent Manager - Store Leadership (DES_1020)",
  "Quality Inspector RPC (DES_1043)",
  "Receiver Dry DC (DES_498)",
  "Circle R&M and Projects Head (DES_873)",
  "Vendor (DES_1082)",
  "Finance Support (DES_860)",
  "Vendor Resource (DES_808)",
  "1011032-SM New Motinagar, Hyderabad-CSA (1011032-SM New Motinagar, Hyderabad-CSA)",
  "Marketing Analyst (DES_655)",
  "TM Category Planning (BEOR0135)",
  "Senior Lead - Employee Relations & Compliances (DES_164)",
  "HR Transformation and Shared Services Manager (DES_1021)",
  "Neosoft Vendor (DES_906)",
  "Admin Facility (DES_804)",
  "National Category Head - Fresh (DES_1003)",
  "Lead  - Talent Sourcing DC (DES_1029)",
  "SDE I (DES_155)",
  "Lead - Category Finance (DES_833)",
  "Area Operations Manager- Supermarket (DES_691)",
  "Quality F&V DC (DES_497)",
  "Lead - HM Projects (DES_878)",
  "Lead - Payroll Compliance and Settlements (DES_1049)",
  "Team Member - Accounts Payable (DES_76)",
  "Chairman - Board of Advisors (DES_424)",
  "F&V Inbound Incharge (DES_798)",
  "Bill passing -SKN 1 (BEOR0036)",
  "R&M Technician (DES_600)",
  "Head- Talent Acquisition and Format HR Head (South) (DES_1033)",
  "Loader RPC (DES_524)",
  "Team Member - Finance SSC (DES_77)",
  "Senior Lead - Corporate Legal (DES_163)",
  "Category Manager (DES_22)",
  "Quality Assistant (DES_1107)",
  "Quality Assistant (DES_1107)",
  "Company Secretary (DES_1108)",
  "Apprentice Part Time (DES_462)",
  "Regional Sourcing Associate (DES_1109)",
  "Inventory Manager (DES_1110)",
  "National Sourcing Head (DES_1111)",
  "Head HR- Retail, Dark Stores and Supply Chain Operations (DES_1112)",
  "National F&V Sourcing Head (DES_1113)",
  "Trainee BD Manager  (DES_1114)",
  "Trainee Circle Marketing Manager (DES_1115)",
  "Receiving Incharge (DES_1117)",
  "Packhouse Incharge (DES_1118)",
  "CSA-Central-Omni (DES_1116)",
  "CSA Part Time (DES_936)",
  "Housekeeper Part Time (DES_938)",
  "Rider & Picker Part Time (DES_940)",
  "Apprentice Part Time (DES_942)",
  "Reliever Security - Dark Store (DES_981)",
  "Picker Part Time - Offroll - Dark Store (DES_944)",
  "Flex Picker Dark Store (DES_980)",
  "Housekeeper Part Time - Offroll - Dark Store (DES_947)",
  "CSA-Promoter Full Time (DES_811)",
  "CSA-Promoter Part Time (DES_810)",
  "Picker Part Time - Offroll - SM (DES_701)",
  "Rider & Picker Full Time - Offroll - SM (DES_702)",
  "Rider & Picker Part Time - Offroll - SM (DES_703)",
  "Milk Associates - Part Time (DES_949)",
  "Milk Delivery Associate (DES_866)",
  "Housekeeper Part Time (DES_138)",
  "Rider & Picker Part Time (DES_681)",
  "Station Support Associate (DES_478)",
  "Housekeeper Part Time - Offroll - HM (DES_786)",
  "Rider & Picker Full Time - Offroll - HM (DES_698)",
  "Rider & Picker Part Time - Offroll - HM (DES_699)",
  "Security Part Time Offroll HM (DES_785)",
  "Store Unloader HM (DES_589)",
  "Promoter HM (DES_588)",
  "Mover RPC (DES_526)",
  "Unloader CC (DES_1041)",
  "Packer CC (DES_1035)",
  "Picker CC (DES_520)",
  "Mover CC (DES_521)",
  "Checker CC (DES_514)",
  "Support F&V DC (DES_1102)",
  "Grader F&V DC (DES_1101)",
  "Loader F&V DC (DES_1100)",
  "Mover F&V DC (DES_1099)",
  "Deputy DC Manager (1119)",
  "HR Analyst (DES_1120)",
  "Receiving Supervisor (DES_1121)",
  "Picking Incharge (DES_1122)",
  "Head- People Operations (DES_1123)",
  "Quality Assistant (DES_1124)",
  "Flex Picker Part Time (DES_1125)",
];
export const jobLevelAndCode = [
  {
    key: "Unloader-Off Roll",
    value: "MRPL_UNLOffROLL",
  },
  {
    key: "Customer Service Associate",
    value: "MRPL_CSA",
  },
  {
    key: "Housekeeping Associate-Off Roll",
    value: "MRPL_HKAOffRoll",
  },
  {
    key: "Junior Officer",
    value: "MRPL_JO",
  },
  {
    key: "Assistant Vice President",
    value: "MRPL_AVP",
  },
  {
    key: "Customer Sales Associate",
    value: "MRPL_CSLA",
  },
  {
    key: "Senior Store Manager",
    value: "MRPL_SSM",
  },
  {
    key: "Store Manager",
    value: "MRPL_STM",
  },
  {
    key: "Managing Director",
    value: "MRPL_MD",
  },
  {
    key: "Senior Officer",
    value: "MRPL_SO",
  },
  {
    key: "Deputy General Manager",
    value: "MRPL_DGM",
  },
  {
    key: "Assistant General Manager",
    value: "MRPL_AGM",
  },
  {
    key: "Senior Vice President",
    value: "MRPL_SV4",
  },
  {
    key: "Customer Service Associate-Off Roll",
    value: "MRPL_CSAOffroll",
  },
  {
    key: "Vice President",
    value: "MRPL_VP",
  },
  {
    key: "Off Roll SM",
    value: "MRPL_SOR",
  },
  {
    key: "Manager",
    value: "MRPL_MGR",
  },
  {
    key: "Supervisor",
    value: "MRPL_SUP",
  },
  {
    key: "Team Leader",
    value: "MRPL_TL",
  },
  {
    key: "Baggage Handler Associate-Off Roll",
    value: "MRPL_BGHOffroll",
  },
  {
    key: "Unloader-Onroll",
    value: "MRPL_UNLONROLL",
  },
  {
    key: "Senior Manager",
    value: "MRPL_SM",
  },
  {
    key: "General Manager",
    value: "MRPL_GM",
  },
  {
    key: "DC Off Roll Employee",
    value: "MRPL_DCOF",
  },
  {
    key: "Chief Executive Officer/ President",
    value: "MRPL_CEOP",
  },
  {
    key: "Senior Vice President",
    value: "MRPL_SV3",
  },
  {
    key: "Off Roll HM",
    value: "MRPL_HOR",
  },
  {
    key: "Housekeeping Associate",
    value: "MRPL_HA",
  },
  {
    key: "Chairman and Board of Advisors",
    value: "MRPL_CBA",
  },
  {
    key: "Intern",
    value: "INT",
  },
  {
    key: "Consultant",
    value: "MRPL_CNT",
  },
  {
    key: "Deputy Manager",
    value: "MRPL_DM",
  },
  {
    key: "Apprentice",
    value: "MRPL_APR",
  },
  {
    key: "Associate",
    value: "MRPL_ASO",
  },
  {
    key: "Assistant Manager",
    value: "MRPL_AM",
  },
  {
    key: "MBLP",
    value: "MBLP",
  },
  {
    key: "Baggage Handler Associate",
    value: "MRPL_BHA",
  },
  {
    key: "Promoter",
    value: "MRPL_PR",
  },
  {
    key: "Officer",
    value: "MRPL_OFC",
  },
  {
    key: "Assistant Store Manager",
    value: "MRPL_ASM",
  },
  {
    key: "Senior General Manager",
    value: "MRPL_SGM",
  },
  {
    key: "Customer Service Supervisor",
    value: "MRPL_CSSP",
  },
  {
    key: "Associate-DC",
    value: "MRPL_ASODC",
  },
  {
    key: "Customer Support Associate",
    value: "MRPL_CSPA",
  },
  {
    key: "Offroll - Dark Store",
    value: "MRPL_DOR",
  },
];
export const businessUnit = [
  { value: "DB ADMIN", color: "#DA3D09" },
  { value: "MD's Office", color: "#D0213D" },
  { value: "HR and Admin", color: "#0062E2" },
  { value: "Store Excellence", color: "#784CD5" },
  { value: "Supply Chain Management", color: "#FF5733" },
  { value: "Tech & Product", color: "#008A29" },
  { value: "Supermarkets", color: "#C70039" },
  { value: "Finance and Accounts", color: "#900C3F" },
  { value: "Legal and Compliance", color: "#581845" },
  { value: "Hypermarkets", color: "#1ABC9C" },
  { value: "CEO's Office", color: "#2ECC71" },
  { value: "Omni", color: "#3498DB" },
  { value: "Dark Store", color: "#9B59B6" },
  { value: "Buying & Merchandising", color: "#34495E" },
  { value: "Marketing", color: "#F1C40F" },
];
export const businessUnitHeadName = [
  "Pawan Sharma (400983)",
  "Sairam Krishnamurthy (371853)",
  "Sudhir Shukla (403536)",
  "Sashi Gumma (48329)",
  "Nemisha Ghia (380853)",
  "Ganesh Subramanian (366101)",
  "Ganesh Subramanian (366101)",
  "Supratim Banerjee (367986)",
  "Giridhar Seetharam (403527)",
  "Vinod Nambiar (368812)",
  "Satish Karunakaran (371883)",
  "Rajesh Channamsetty (372725)",
  "Pawan Sharma (400983)",
  "Sairam Krishnamurthy (371853)",
  "Mohit Kampani (259042)",
  "Priyanka Agrawal (372857)",
  "Ranjana Saboo (370672)",
  "Sudhir Shukla (403536)",
  "Laxman Ramnarayan (381817)",
  "Mansee Jain (374651)",
];
export const departmentCode = [
  "584_DS",
  "632_APSMK",
  "DD_1",
  "504_BDH",
  "509_RHO",
  "SM 628",
  "519_SMA",
  "519_SMH",
  "515_SMK",
  "642_E&C",
  "509_SME",
  "595_PCH",
  "632_APHME",
  "629_HM",
  "653_SE1",
  "645_CS",
  "516_B&MOTH",
  "HM 584",
  "564_CCF&V-B&M",
  "512_SME",
  "509_HRAL1",
  "509_HRPO",
  "505_CEO",
  "509_TAM",
  "628_HM",
  "SCM 523",
  "519_DS",
  "636_SMH",
  "631_PTSMA",
  "565_STP",
  "SM 526",
  "584_POMHME",
  "628_DS",
  "632_APSMN",
  "514_L&CL1",
  "633_SSC",
  "629_SM",
  "514_COL",
  "584_SM",
  "504_SMH",
  "SM 631",
  "639_ONI",
  "512_SMT",
  "566_ETB",
  "631_HM",
  "507_TAX",
  "309_B&M Lifestyle",
  "512_NIM",
  "509_ADM",
  "SM 519",
  "650_BE",
  "632_SM",
  "509_FLD",
  "563_SFH",
  "512_SMH",
  "652_P&R&M",
  "311_B&M SSC",
  "636_SME",
  "519_HS2",
  "519_SMK",
  "512_SND",
  "507_DPC",
  "579-SPG",
  "654_CLP",
  "509_Pay",
  "638_SCM",
  "523_SCM",
  "647_B2B&IS",
  "507_FIN",
  "310_B&M Fresh",
  "629_DS",
  "633_SSCF&A",
  "636_SMK",
  "512_SMK",
  "523_DCO",
  "632_DS",
  "519_HM",
  "507_FCL",
  "504_SME",
  "631_SM",
  "N.A.",
  "636_SMS",
  "632_APSME",
  "523_SME",
  "519_SM",
  "512_ITPL1",
  "505_CSML1",
  "632_HM",
  "507_ACT",
  "507_SMH",
  "512_ITS",
  "628_HKSMH",
  "519_SMN",
  "507_ACP",
  "504_SMN",
  "522_SCM",
  "507_PRC",
  "635_PRD",
  "519_HME",
  "643_MMA",
  "640_SCM",
  "561_F&G",
  "HR-SSC",
  "564_SMA",
  "509_SMK",
  "182_MDOL1",
  "584_HM",
  "514_CMP",
  "519_HS1",
  "646_BD",
  "636_SCM",
  "SM 584",
  "504_SMK",
  "519_HMN",
  "628_SM",
  "512_SMN",
  "HM 519",
  "515_SMH",
  "651_HM",
  "564_B&MCCF&V",
  "SM 632",
];
export const departmentHierarchy = [
  "South 1 Circle (KN&MH) SM|Business Development SM|Supermarkets",
  "DC Ops|Supply Chain Management",
  "Apprentice SM|South 1 Circle (KN&MH) SM|Retail Ops SM|Supermarkets",
  "Omni LM-Amazon",
  "FMCG|Buying & Merchandising",
  "FE L&D and CBP|HR and Admin",
  "Taxation|Financial Control|Finance and Accounts",
  "RPC|Supply Chain Management",
  "External Brand|Apparel & Footwear",
  "Business Development|CEO's Office",
  "Equity & Communication",
  "East Circle HM|Retail Ops HM|Hypermarkets",
  "TG Circle SM|Merchandise Procurement|Supply Chain Management",
  "East circle SM|SM HR|HR and Admin",
  "Space Planning|Buying & Merchandising",
  "Projects and Maintenance|Retail Ops SM|Supermarkets",
  "Payroll|Rewards & HR Ops|HR and Admin",
  "DC Operations|Supply Chain Management",
  "Apprentice HM|East Circle HM|Retail Ops HM|Hypermarkets",
  "TG Circle SM|Retail Ops SM|Supermarkets",
  "Talent|HR and Admin",
  "CEO's Office",
  "TG Circle SM|DC Operations|Supply Chain Management",
  "Projects & R&M",
  "Store Operations Team|Retail Ops HM|Hypermarkets",
  "Rewards & HR Ops|HR and Admin",
  "Apprentices|Store Operations Team|Retail Ops HM|Hypermarkets",
  "Legal and Compliance",
  "Pickers and Store Omni",
  "Part timers CSA SM|AP Circle SM|Retail Ops SM|Supermarkets",
  "AP Circle SM|Retail Ops SM|Supermarkets",
  "Housekeeping HM|South2 Circle HM|Retail Ops HM|Hypermarkets",
  "North Circle SM|Business Development SM|Supermarkets",
  "Store Operations Team",
  "IT Services|Networks & Infrastructure Mgmt|IT and Product",
  "Marketing SM|Supermarkets",
  "North Circle SM|Retail Ops SM|Supermarkets",
  "Housekeeping SM|TG Circle SM|Retail Ops SM|Supermarkets",
  "TG Circle SM|Loss Prevention (Shrinkage Control) SM|Supermarkets",
  "Compliance|Legal and Compliance",
  "Apprentice SM|East circle SM|Retail Ops SM|Supermarkets",
  "North Circle HM|Retail Ops HM|Hypermarkets",
  "Baggage Handlers|Store Operations Team|Retail Ops SM|Supermarkets",
  "KE & TN Circle SM|IT Services|Networks & Infrastructure Mgmt|IT and Product",
  "South2 Circle HM|Retail Ops HM|Hypermarkets",
  "Security|Store Operations Team|Retail Ops HM|Hypermarkets",
  "Supermarkets",
  "Omni",
  "East circle SM|Business Development SM|Supermarkets",
  "B&M - SSC|Buying & Merchandising",
  "Business Development HM|Hypermarkets",
  "Super Fresh|Buying & Merchandising",
  "Financial Control|Finance and Accounts",
  "Product Dept|IT and Product",
  "HR Partnering - Format and SCM Operations|HR and Admin",
  "Apprentices",
  "TG Circle SM|IT Services|Networks & Infrastructure Mgmt|IT and Product",
  "Customer Support",
  "Marketing Media & Activation",
  "Customer Service Associate - Part Time|Store Operations Team|Retail Ops HM|Hypermarkets",
  "South 1 Circle (KN&MH) SM|Loss Prevention (Shrinkage Control) SM|Supermarkets",
  "Merchandise Procurement|Supply Chain Management",
  "House Keeping|Store Operations Team|Retail Ops HM|Hypermarkets",
  "Store Operations Team|Retail Ops SM|Supermarkets",
  "Project Omni|East Circle HM|Retail Ops HM|Hypermarkets",
  "TG Circle SM|Business Development SM|Supermarkets",
  "Accounting|Financial Control|Finance and Accounts",
  "North Circle SM|IT Services|Networks & Infrastructure Mgmt|IT and Product",
  "Networks & Infrastructure Mgmt|IT and Product",
  "Packhouse",
  "B&M Controller|Finance and Accounts",
  "Security",
  "Customer Service Associate - Part Time|Store Operations Team|Retail Ops SM|Supermarkets",
  "Corporate Legal|Legal and Compliance",
  "Finance Shared Services Centre|Financial Control|Finance and Accounts",
  "IT and Product",
  "Pickers and Store Omni|Store Operations Team|Retail Ops HM|Hypermarkets",
  "Admin|HR and Admin",
  "East circle SM|IT Services|Networks & Infrastructure Mgmt|IT and Product",
  "House Keeping|Store Operations Team|Retail Ops SM|Supermarkets",
  "Pickers and Store Omni|Store Operations Team|Retail Ops SM|Supermarkets",
  "B&M - Life Style|Buying & Merchandising",
  "B&M - Circle Category F&V|F&V|Buying & Merchandising",
  "B&M- Others|Buying & Merchandising",
  "Compliance and Loss Prevention",
  "Store Excellence",
  "AP Circle SM|F&V|Buying & Merchandising",
  "Staples Procurement|Supply Chain Management",
  "South 1 Circle (KN&MH) SM|Merchandise Procurement|Supply Chain Management",
  "Apprentices|Store Operations Team|Retail Ops SM|Supermarkets",
  "Accounts Payable|Financial Control|Finance and Accounts",
  "TG Circle SM|Circle Commercial SM|Finance and Accounts",
  "Superfresh|Buying & Merchandising",
  "South 1 Circle (KN&MH) SM|IT Services|Networks & Infrastructure Mgmt|IT and Product",
  "South 1 Circle (KN&MH) SM|SM HR|HR and Admin",
  "South1 Circle HM|Retail Ops HM|Hypermarkets",
  "East circle SM|DC Ops|Supply Chain Management",
  "Dummy Department",
  "Procurement|Finance and Accounts",
  "Business Excellence",
  "South 1 Circle (KN&MH) SM|Retail Ops SM|Supermarkets",
  "HR and Admin",
  "B2B and Institutional Sales|CEO's Office",
  "House Keeping",
  "Quality Control",
  "Apprentice SM|North Circle SM|Retail Ops SM|Supermarkets",
  "East circle SM|Merchandise Procurement|Supply Chain Management",
  "Finance and Accounts",
  "mymore HR Services|Rewards & HR Ops|HR and Admin",
  "MD's Office",
  "B&M Staples|Buying & Merchandising",
  "IT Solution & Delivery|Networks & Infrastructure Mgmt|IT and Product",
  "Shared Services Centre|Financial Control|Finance and Accounts",
];
export const groupCompanyCode = ["MRPL", "MCBPL"];
export const baseOfficeLocation = [
  "Chittoor (SM Samalkota, Kakinada) (1013786)",
  "Dharwad (SM Bendre Nagar) (1523494)",
  "Kolkata (Bongaon Kolkata) (8003263)",
  "Vijayawada (SM Palasa, Vizag) (1351962)",
  "Bangalore (SM Kushal Nagar) (1703511)",
  "Mumbai (Skyline Icon-Corp SM) (20024_SM)",
  "Bangalore (Old Airport Road HM Bangalore) (1503184)",
  "Ghaziabad Ghaziabad (HM Galaxy) (6513668)",
  "Bangalore (Bull Temple - Bangalore Hypermarket) (1502012)",
  "Berhampore (HM Berhampore) (8003670)",
  "Chennai (Adambakkam) (2001186)",
  "Kolkata (Belghoria Kolkata) (8003224)",
  "Bangalore (R R Nagar BEML Layout Bangalore) (1503219)",
  "Kolkata (Basirhat) (8003391)",
  "Nuzvid Nuzvid (SM Nuzvid, Vijayawada) (1153792)",
  "Kottayam (Aluva) (2501221)",
  "Bangalore (SM Hospet-Bellary Road) (1713863)",
  "Ongole (HM KVR Mall, Ongole - AP) (1153527)",
  "Vizag (Tadepalligudem) (1231283)",
  "Hyderabad (Saroornagar HM) (1011992)",
  "Sonipat (Sonipat Dry DC) (32)",
  "Pune (Pune Zonal Office- HO) (3210100_HO)",
  "Hyderabad (SM Circuit Road, Hyderabad) (1021087)",
  "Kolkata (FREE SCHOOL STREET) (8001569)",
  "Hyderabad (Rajappa Nagar High court colony Hyderaba) (1013276)",
  "Bangalore (Bannerghatta Bangalore Circle Office- SM) (1500102_SM)",
  "Hyderabad (SM New Motinagar, Hyderabad) (1011032)",
  "Mohali (SM Phase 11, Mohali) (5531655)",
  "Balasore (HM Balasore, Odisha) (8503816)",
  "Hyderabad (Shad Nagar) (1013227)",
  "Bengaluru (Infosys) (1504053)",
  "Gadag (Gadag) (1711998)",
  "Kolkata (SHYAMNAGAR ROAD) (8001451)",
  "Vizag (SM Yendada,Vizag) (1353501)",
  "Patiala (Patiala Bhadson Road) (5521806)",
  "Raichur (SM Raichur-Mantralaya Rd) (1713525)",
  "Srikakulam (SM Tekkali) (1353962)",
  "Vijayawada (Vijayawada ZO) (1150100)",
  "Kolkata (Midnapore) (8023290)",
  "Mumbai (Skyline Icon-HO) (20024)",
  "Tirupati (Bhiragipattada - Tirupathi) (1271357)",
  "Visakhapatnam (HM Surya Central Mall, Vizag - AP) (1153528)",
  "Orissa (HM Jharsuguda, Odisha) (8503775)",
  "Mumbai (Skyline Icon-HM) (20024_HM)",
  "N.A.",
  "Delhi (Noida Office HM- Corp HM) (6503435_CHM)",
  "Kolkata (Kolkata ZO (Industry House 7th Floor)) (8000103)",
  "Vizag (Mungamur Road) (1202010)",
  "Vizag (Shivaji Junction Tenali) (1162083)",
  "Vijayawada (Palamaneru F&V CC) (812)",
  "03184 Bangalore (Old Airport Road HM Bangalore) (1503184)",
  "Kolkata (Kolkata ZO (Industry House 7th Floor)- HO) (8000103_HO)",
  "Vijayawada (Venkat Nagar, Kakinada) (1372039)",
  "Vijayawada (Pendurthy) (1351316)",
  "Patiala (Patiala Urban Estate 2) (5521606)",
  "Hyderabad (SM Nizampet, Hyderabad) (1011064)",
  "Bangalore (SM Kushal Nagar) (1703511)",
  "Hyderabad (Banjara Hills (Erramanzil) Hyderabad HM) (1011990)",
  "Chennai (Chennai ZO- HO) (2000100_HO)",
  "Muzaffarnagar Cochin (SM Edappal) (2603832)",
  "Chandigarh (Chandigarh Sector 37) (5551956)",
  "Bangalore (DOMLUR) (1501594)",
  "Mangalore (SM Bajpe-Mangalore) (1703558)",
  "Vizag (Kapilateertham Road) (1272009)",
  "Tirupati (MR Palli -Tirupathi) (1271356)",
  "Kolkata (City Center Durgapur) (8053064)",
  "Bangalore (Doddaballapur) (1502033)",
  "Bangalore (Bannerghatta Bangalore Circle Office- HO) (1500102_HO)",
  "Jalandhar (Guru Gobind Singh Nagar Jalandhar) (5593311)",
  "Vizag (Chirala) (1143223)",
];
export const locationType = [
  "wadepally hanamkonda",
  "more. Thrikkakara",
  "more. Thodupuzha",
  "more. Vennala",
  "more. Vattiyoorkavu",
  "more. Tripunithura",
  "more. Thiruvalla",
  "more. Samkranti Kottayam",
  "more. Prashant Nagar",
  "more. Ponkunnam",
  "more. Pathanamthitta",
  "more. Paruthipara",
  "more. Panampilly Nagar",
  "more. Pachalam",
  "more. North Paravoor",
  "more. Mulanthuruthy",
  "more. Marappalam",
  "more. Mannarkad",
  "more. Kurishumoodu Chenganassery",
  "more. Kottayam",
  "more. Koovapaddam",
  "more. Kolencherry",
  "more. Kesavampady",
  "more. Kayamkulam",
  "more. Kakkanadu",
  "more. Haripad",
  "more. General Hospital Jn.",
  "more. Ettumanoor Kottayam",
  "more. Changanassery",
  "more. Ambalamukku",
  "more. Aluva",
  "more. Adoor",
  "Zangra",
  "Yelahanka Dark Store - KA",
  "YENDADA",
  "Wipro",
  "Warangal Dark Store - TG",
  "Wanaparthy",
  "WB Kolkata Rajarhat HM",
  "WB Burdwan GT Road HM",
  "WB Behrampore Mohan Mall HM",
  "Vontikoppal Mysore",
  "Vizag Sector of Hyderabad",
  "Vizag Sector of Bangalore",
  "Vizag Scrap Sale",
  "Vizag Fnv Dc",
  "Vizag Dry DC IS - AP",
  "Vizag Dry DC",
  "Vivek Nagar Hassan - KA",
  "Virajpet Kodagu",
  "Vikas Nagar Dark Store Lucknow - UP",
  "Vikarabad - TG",
  "Vijayawada ZO",
  "Vijayawada Sector of Hyderabad",
  "Vijayawada Sector of Bangalore",
  "Vijayawada Scrap Sale",
  "Vijayawada FnV Dc",
  "Vijayawada Dry DC IS - AP",
  "Vijayawada Dry DC",
  "Vijaya Mall Thiruvannamalai",
  "Vijaya Layout",
  "Vijay Nagar Hassan",
  "Vignana Nagar (Kagadaspura)",
  "Vidyanagar Hubli Dark Store - KA",
  "Vidyanagar Davangere - KA",
  "Vidya Nagar Kothagudam",
  "Vasundhara Sector 13",
  "Vasundhara Sector 12",
  "Varthur Road Bangalore",
  "Valencia Gen Three",
  "VIP Road Zirakpur",
  "VINAYAKA NAGAR",
  "Ushodaya Junction Vizag",
  "Urwa Market Dark Store Mangalore - KA",
  "Urmar Tanda Hoshiarpur - PJ",
  "Urban Estate Sec 10 Jind NCR",
  "Urban Estate PH2 Jalandhar - PJ",
  "Uralpatti F&V Cc",
  "Uppinangadi SKN",
  "Unble Nagar Dry DC Pune IS- MH",
  "Una - HP",
  "Ultratec-Tadipatri",
  "Udayamperoor",
  "UP Greater Noida OCP HM",
  "UP Gorakhpur Medical College Road HM",
  "UP Agra Padam High Street HM",
  "UBO8 AMAZON RETAIL INDIA PVT LTD",
  "Tumkur Sit Road",
  "Toopran",
  "Tonchikoppal Mysore",
  "Tiruvanamalai Sky Star Plazaa",
  "Tirupattur",
  "Tirupati Dark Store - AP",
  "Tiruchanur Tirupathi",
  "Tiptur Vinayaknagar - KA",
  "Tiptur",
  "Thuravur Cochin ZO",
  "Thuravur Cochin Project DC - KL",
  "Thuravur Cochin DC - KL",
  "Thumpamon - KL",
  "Thummalagunta Tirupathi AP",
  "Thumkunta - TG",
  "Thrikkakara Dark Store - KL",
  "Thoravur Cochin FnV",
  "Thoraipakkam Dark Store Chennai - TN",
  "Thiruporur- Chennai - TN",
  "Thalayolaparambu KL",
  "Tekkali AP",
  "Teachers Colony Ananthapur",
  "Tarikere",
  "Tarihal Hubli ZO",
  "Tarihal Hubli DC IS- KA",
  "Talikoti",
  "TUMKUR 3",
  "TIRUVURU",
  "TC Palya 2",
  "Suryapet",
  "Suri Birbhum",
  "Surathkal",
  "Sunam",
  "Sullia",
  "Sukchar Sodepur",
  "Suchitra Pipe Line Road Dark Store Hyderabad - TG",
  "Subbanna Garden Vijayanagar",
  "Steamer Road Narsapuram",
  "Sriram Hills Khammam",
  "Srinivas Nagar Bank Colony",
  "Srinagar Dharwad - KA",
  "Sompeta AP",
  "Somawarpet",
  "Skyline Icon-HO",
  "Sirhind",
  "SircillaTelangana",
  "Sira",
  "Sinthi Dum Dum",
  "Singapura - SKN",
  "Sindhanur",
  "Sindagi",
  "Sikaripura-NKN",
  "Sikandra Agra-1 Dark Store - UP",
  "Sholinganallur SM Chennai TN",
  "Shirur Park Road Hubli - KA",
  "Shimoga Savalang",
  "Sheoraphuli - WB",
  "Shankar Nagar",
  "Shakuntala Park Behala Kolkata",
  "Shahabad Ladwa Road - HR",
  "Shahabad Haryana CC",
  "Shad Nagar",
  "Sentrum Mall Krishnagar - WB",
  "Sempla Sirhind (Chunni) ZO",
  "Sempla Sirhind (Chunni) Project DC",
  "Sector 9 - Ambala - HR",
  "Sector 17 Huda Market Jagadhri - HR",
  "Sec 126 Kharar - PJ",
  "Saundatti NKN",
  "Sathvik Agro-Food Industries Private Limited",
  "Sathupalli TG",
  "Saroor Nagar 2 Dark Store Hyderabad TG",
  "Saroor Nagar 1 Dark Store Hyderabad TG",
  "Sarjapura Dark Store Bangalore - KA",
  "Saraswathipuram Mysore - KA",
  "Santipur UPC Kolkata - WB",
  "Santhi Nagar Eluru - AP",
  "Sanivarapupeta Eluru AP",
  "Sangrur",
  "Sangola (Mahud Road) F&V CC",
  "Samana PB",
  "Samalkot - AP",
  "Salt Lake",
  "Sakaleshpura SKN",
  "Sainikpuri Dark Store Hyderabad - TG",
  "Sahara Estate Hyderabad",
  "Sahakarnagar-3 Dark Store Bangalore - KA",
  "Sahakarnagar-2 Dark Store Bangalore - KA",
  "Sagara",
  "Sagar Road Miryalguda",
  "Sagar Nagar Vizag",
  "Sadashivpet - TG",
  "SVN Colony Guntur - AP",
  "SULLURPET",
  "SONIPAT FNV DC PACKHOUSE",
  "SM Yemmiganur",
  "SM Vizag Shankarmattam Rd",
  "SM Vizag Rajam",
  "SM Vizag Railway New Colony",
  "SM Vizag Pendurthy",
  "SM Vizag Parvathipuram",
  "SM Vizag Nouroji Road",
  "SM Vizag Narsipatnam",
  "SM Vizag NCS Multiplex Vizianagaram",
  "SM Vizag Muralinagar",
  "SM Vizag Madhurvada",
  "SM Vizag Kurumanpalem",
  "SM Vizag KT Road Palasa",
  "SM Vizag Gopalapatnam",
  "SM Vizag Gajuwaka Kanithi road TP",
  "SM Vizag Gajuwaka",
  "SM Vizag Dutt Island",
  "SM Vizag Bobbili",
  "SM Vizag Beach Road",
  "SM Vizag Balashasdri Layout",
  "SM Vizag Anakapalli",
  "SM Vizag Akkayapalem",
  "SM Vijayawada Venkat Nagar Kakinada",
  "SM Vijayawada Vedaiahpalem",
  "SM Vijayawada Tadepalligudem",
  "SM Vijayawada Shivaji Junction Tenali",
  "SM Vijayawada Rotary nagar- khammam 3",
  "SM Vijayawada Raparthi Nagar-Khammam-2",
  "SM Vijayawada Palavancha",
  "SM Vijayawada Narasaraopeta",
  "SM Vijayawada NR Pet Eluru",
  "SM Vijayawada Mungamur Road",
  "SM Vijayawada Maganti Layout",
  "SM Vijayawada MSR Circle",
  "SM Vijayawada MR pally",
  "SM Vijayawada Khammam",
  "SM Vijayawada Karanamgari Jn KKD3",
  "SM Vijayawada Kandukuru",
  "SM Vijayawada K T Road",
  "SM Vijayawada K R Palli",
  "SM Vijayawada Gudiwada",
  "SM Vijayawada Central Plaza Eluru",
  "SM Vijayawada Bairagipattada",
  "SM Vijayawada Ashok Nagar",
  "SM T and E HPCL KOLKATA WB",
  "SM Ramchandra Puram AP",
  "SM Ramaraopet",
  "SM R V Nagar",
  "SM Nadia Kalyani",
  "SM Mysore New KD Road",
  "SM Mangalore Pandeshwar",
  "SM Mangalore Manipal Udupi",
  "SM Mangalore Janani Kadri",
  "SM Mangalore Dheralakatte",
  "SM Mangalore Chilambi",
  "SM Mangalore Bolwar",
  "SM Mangalore Bendur Agnus",
  "SM Mangalore Bejai",
  "SM Mangalore Alake",
  "SM Kuvempunagar Chanapatana",
  "SM Kolkata Vidya Appartment Parnasree Pally",
  "SM Kolkata Uttarpara",
  "SM Kolkata Uttara Complex Sodepur",
  "SM Kolkata Shyamnagar Road",
  "SM Kolkata Sengupta Apt Akra Santoshpur",
  "SM Kolkata School Road Birati 2",
  "SM Kolkata Satyabhavan Haridevpur",
  "SM Kolkata Omega Apartment Dumdum Road",
  "SM Kolkata Krishan Kunjo",
  "SM Kolkata Kanchrapara",
  "SM Kolkata Jessore Road Madhyamgram",
  "SM Kolkata James Residency Behala",
  "SM Kolkata Jagadhatri Apartment Chandan",
  "SM Kolkata Hindmotor",
  "SM Kolkata Ghosh Palace Budgebudge",
  "SM Kolkata Free School Street",
  "SM Kolkata Elliot Road",
  "SM Kolkata Durgapur",
  "SM Kolkata Durga Apartment Khardah",
  "SM Kolkata Disco Palace",
  "SM Kolkata Diamond Harbour Road 2",
  "SM Kolkata Bataitala Howrah",
  "SM Kolkata Barasat",
  "SM Karimnagar Mankamma Thota",
  "SM IS Hyderabad",
  "SM IS Bangalore",
  "SM Hyderabad Zaheerabad",
  "SM Hyderabad Yapral",
  "SM Hyderabad Tarnaka",
  "SM Hyderabad Tandur",
  "SM Hyderabad Siripuram Colony",
  "SM Hyderabad Siddipet",
  "SM Hyderabad Seethaphalmandi",
  "SM Hyderabad Santhinagar",
  "SM Hyderabad Sangareddy",
  "SM Hyderabad Saidabad",
  "SM Hyderabad Ramgundam",
  "SM Hyderabad RAJIV PARK - KDP2",
  "SM Hyderabad Proddutoor",
  "SM Hyderabad Nizampet",
  "SM Hyderabad Nirmal",
  "SM Hyderabad New Snehapuri",
  "SM Hyderabad New P&T Colony",
  "SM Hyderabad New Motinagar",
  "SM Hyderabad Nethaji Nagar",
  "SM Hyderabad Nandyal",
  "SM Hyderabad Nallakunta",
  "SM Hyderabad Nalagonda",
  "SM Hyderabad NGO COLONY- KADAPAH",
  "SM Hyderabad N R Pet Kurnool",
  "SM Hyderabad Moula Ali",
  "SM Hyderabad Meerpet",
  "SM Hyderabad Manchiryala",
  "SM Hyderabad Madav Nagar",
  "SM Hyderabad Kanteshwar",
  "SM Hyderabad Kamareddy",
  "SM Hyderabad Jyotinagar",
  "SM Hyderabad Jp Nagar",
  "SM Hyderabad Hayathnagar",
  "SM Hyderabad Habsiguda",
  "SM Hyderabad HUDA",
  "SM Hyderabad Gandhinagar",
  "SM Hyderabad Gadwal",
  "SM Hyderabad Ferojguda",
  "SM Hyderabad ECIL Kamala Nagar",
  "SM Hyderabad Dammaiguada",
  "SM Hyderabad Circuit House",
  "SM Hyderabad Chikkadpally",
  "SM Hyderabad Boduuppal",
  "SM Hyderabad Barkatpura",
  "SM Hyderabad Balapur",
  "SM Hyderabad BOUDHA NAGAR",
  "SM Hyderabad B N reddy Nagar",
  "SM Hyderabad Arunodaya Nagar",
  "SM Hyderabad Adoni",
  "SM Hyderabad A S Rao Nagar",
  "SM Hubli Vidyagiri",
  "SM Hubli Vidya Nagar",
  "SM Hubli Tilakwadi",
  "SM Hubli Sirur Park",
  "SM Hubli Silver Town",
  "SM Hubli Sholapur Road",
  "SM Hubli Sapthapur",
  "SM Hubli SN Pet",
  "SM Hubli Ranebennur",
  "SM Hubli Nijalingappa Road",
  "SM Hubli Navanagar",
  "SM Hubli Mulgundnaka",
  "SM Hubli Malkhed",
  "SM Hubli Kusugal Road",
  "SM Hubli Kolhapur Circle",
  "SM Hubli Infantry Road Bellary",
  "SM Hubli Haveri",
  "SM Hubli Harihar Store",
  "SM Hubli Hadadi Road",
  "SM Hubli Dr.Pickle road",
  "SM Hubli Devekere Road Sirsi",
  "SM Hubli DHO",
  "SM Hubli College Road",
  "SM Hubli Anjaneya Nagar",
  "SM Hubli ACC Wadi",
  "SM Howrah Sreerampore",
  "SM Hoogly Swapna Neer Konnagar",
  "SM Gopalagouda Extension Shivamoga",
  "SM Elamakkara",
  "SM Dharwad Station Road",
  "SM Debi Service Station HPCL KOLKATA - WB",
  "SM Chennai Vellore -3",
  "SM Chennai Vellore -2",
  "SM Chennai Vellore",
  "SM Chennai Thorapakkam",
  "SM Chennai Thiruvannamalai 2",
  "SM Chennai Thiruvallur",
  "SM Chennai Tambaram West",
  "SM Chennai Tambaram",
  "SM Chennai T. Nagar",
  "SM Chennai Ranipet",
  "SM Chennai Rangarajpuram",
  "SM Chennai R.A.Puram",
  "SM Chennai Pondichery - 2",
  "SM Chennai Myalpore",
  "SM Chennai Melvisharam",
  "SM Chennai Madipakkam",
  "SM Chennai Madhavaram",
  "SM Chennai Kalpakkam",
  "SM Chennai Jones road",
  "SM Chennai Iyyappa Nagar",
  "SM Chennai Cuddalore",
  "SM Chennai Choolaimedu",
  "SM Chennai CIT Nagar",
  "SM Chennai Annanagar West",
  "SM Chennai Adambakkam",
  "SM Bangalore Yelahanka II",
  "SM Bangalore V V Puram",
  "SM Bangalore TC Palya",
  "SM Bangalore Shankar Nagar",
  "SM Bangalore Sahakarnagar",
  "SM Bangalore Rr Nagar 2",
  "SM Bangalore Rajajinagar",
  "SM Bangalore Narayanpura",
  "SM Bangalore Mosque Road",
  "SM Bangalore Mathikere",
  "SM Bangalore Maruthinagar",
  "SM Bangalore Mallespalya",
  "SM Bangalore Kurubra Halli",
  "SM Bangalore Koramangala 8 Block",
  "SM Bangalore Kodigehalli",
  "SM Bangalore Kammanahalli",
  "SM Bangalore Kalkere",
  "SM Bangalore Jayamahal",
  "SM Bangalore Jaya Ngr 8 Block",
  "SM Bangalore J P Nagar 5Th Ph",
  "SM Bangalore Hulimavu",
  "SM Bangalore Hoskote",
  "SM Bangalore Hessargatta",
  "SM Bangalore HSR Layout",
  "SM Bangalore Girinagar",
  "SM Bangalore Gayathri Nagar",
  "SM Bangalore Domlur",
  "SM Bangalore Doddaballapur",
  "SM Bangalore Devasandra",
  "SM Bangalore Cil Layout",
  "SM Bangalore Brook Field",
  "SM Bangalore Brindavan Nagar",
  "SM Bangalore Banandur Bidadi",
  "SM Bangalore Annapurneshwari Ngr",
  "SM Bangalore Airport Road",
  "SM Asansol Sahara Complex",
  "SM Armoor Nizamabad",
  "SM Amalapuram",
  "SM 57th Street Korattur TN",
  "SIRUGUPPA",
  "Ropar",
  "Rithala Dark Store - DL",
  "Rishi Apartment",
  "Ring Road-Vizianagaram",
  "Rayachoti",
  "Ravulapalem F&V CC",
  "Raniganj Kolkata",
  "Ranaghat",
  "Rampurhat - WB",
  "Ramnagar",
  "Ramji Nagar Nellore",
  "Ramdurg - NKN",
  "Ramapuram Kerala",
  "Rama Road Dark Store - DL",
  "Rajpura",
  "Rajnagar Hubli",
  "Rajnagar Extension North",
  "Rajarhat Mani Ratnam Complex - Kol",
  "Rajarhat",
  "Rajappa Nagar High court colony Hyderabad",
  "Rajajinagar Bangalore",
  "Railway Road - Karnal - HR",
  "Raikot - PJ",
  "Raichur-Mantralaya Rd",
  "Raghunathganj - WB",
  "RT Nagar store",
  "RPC Pune",
  "RPC Kolkata Badu Madhyamgram Processing Location",
  "RPC Kolkata",
  "RPC Hyderabad Processing Location",
  "RPC Hyderabad",
  "RPC Cochin",
  "RAI RPC SONIPAT",
  "RAI RPC PROCESSING CENTRE SONIPAT",
  "RAI F&V DC SONIPAT",
  "RAI Dry DC SONIPAT IS - 2",
  "Qadian Gurdaspur - PJ",
  "Puttur 2",
  "Puttur",
  "Puttaparthi",
  "Punjab Sector of Delhi",
  "Punjab Scrap Sale",
  "Punjab Dry DC",
  "Pune Ubale Nagar Dry DC New Virtual",
  "Pune Sector of Bangalore",
  "Pune F&V Cold Storage (Ecozone)",
  "Puliyarakonam South KL",
  "Project DC two Devarayamjal TG",
  "Prestige Notting Hill - KA2",
  "Pressman Dark Store - WB",
  "Prafulla Kanan",
  "Poranki Vijaywada",
  "Poonamallee Chennai F&V",
  "Piravom",
  "Pileru",
  "Phase 9 Mohali Dark Store PJ",
  "Phagwara",
  "Peddapally - TG",
  "Pavagada SKN",
  "Patiala YPS Road",
  "Patiala Urban Estate 2",
  "Patiala Urban Estate 1",
  "Patiala Sirhind Road",
  "Patiala Model Town Bhupindera Road",
  "Patiala Bhadson Road",
  "Pathanapuram",
  "Pathanamthitta Transit WH",
  "Pathanamthitta 2 Kerala",
  "Parumala - KL",
  "Parcus Road Burdwan",
  "Parakode Kerala",
  "Pandalam",
  "Panampilly Nagar Kochi Dark Store - KL",
  "Pambadi Kerala",
  "Palta",
  "Pallom KL",
  "Pallickathodu Kerala",
  "Palakonda - AP",
  "Padvinangadi Mangalore",
  "Padubidri SKN",
  "Padil Mangalore",
  "PUNJAB FNV DC PACKHOUSE",
  "PUNGANUR",
  "PULIVENDHULA",
  "PALASA 2 AP",
  "Omalloor Pathanamthitta Fnv Packhouse",
  "Omalloor Pathanamthitta Fnv DC",
  "Olakkur NH Road FNV CC - TN",
  "OMR Dark Store Bangalore - KA",
  "Nungi",
  "Noida Extension Dark Store - UP",
  "Nizamabad Three",
  "Niveditha Nagar",
  "Nipun Saffron Arcade Dark Store Ghaziabad - UP",
  "Nipun Mall Ghaziabad",
  "Nippani Road Chikkodi",
  "New Tippasandra Store",
  "New Sonarpur Dream Park - - Kol",
  "New RPC Bangalore Processing Location",
  "New Panipat FNV CC",
  "New Hoskote FnV DC",
  "New Bendre Nagar- Dharwad",
  "New Barrackpore",
  "New Arya Nagar Dark Store - UP",
  "Nelamangala",
  "NawaShahar",
  "Nashik F&V Onion Storage Facility (IMPERIAL) - MH",
  "Narsampet",
  "Narayangaon National F&V CC (Unisol) - MH",
  "Nandagarh Barasat - WB",
  "Nallakunta Dark Store Hyderabad - TG",
  "Nalgonda 3",
  "Nakodar Road Jalandhar-1 Dark Store - PJ",
  "Nakodar Road Jalandhar",
  "Nakodar - PJ",
  "Naka Chowrasta Karimnagar - TG",
  "Najafgarh Dark Store DL",
  "Nagarkarnool",
  "Nagamangala - SKN",
  "Nabha College Road",
  "Nabagram",
  "Nabadwip",
  "NSR Howrah - WB",
  "NGO Colony Warangal",
  "Mysr Vijayanagar",
  "Mysr Sidhartha Lyt",
  "Mysore Dark Store - KA",
  "Mylavaram AP",
  "Muttuchira - KL Central",
  "Munnekollal Bangalore",
  "Mundargi",
  "Mullanpur Distt. Ludhiana PB",
  "Muktsar - PJ",
  "Mudigere",
  "Mudhol NKN",
  "Mourigram",
  "Morinda",
  "Moore Avenue",
  "Mollar Gate Kolkata",
  "Mittal Road Moga",
  "Midnapore",
  "Midanapur -2",
  "Michael Nagar Kolkata - WB",
  "Menamkulam Dark Store Trivandrum - KL",
  "Melapuram Circle Hindupuram - AP",
  "Mehndipur Balachaur - PJ",
  "Mehaboob Towers Ananthapur",
  "Medak",
  "Mavelikkara",
  "Marathalli Dark Store Bangalore - KA",
  "Manuguru - TG",
  "Mansa",
  "MankunduProjDC",
  "Manjadi Thiruvalla 2",
  "Manganam Kurisu Jn Kottayam",
  "Mangalore Sector of Bangalore",
  "Mangalore FnV DC",
  "Mangalore Dry DC",
  "Mandya two",
  "Mandya Mysore",
  "Mandya CC",
  "Manarcud KL",
  "Malur Collection Centre Karnataka",
  "Mallur",
  "Mallappally Kerala",
  "Mallampeta Hyderabad",
  "Malerkotla Punjab CC",
  "Malavalli",
  "Majitha Road Amritsar-1 Dark Store - PJ",
  "Maharanipet Krishna Nagar - AP",
  "Mahadevpura HM Bakery Butchery Production",
  "Mahadevapura - Project DC",
  "Mahabubabad - TG",
  "Mahaboob Nagar Store",
  "Madiwala HM Bakery Butchery Production",
  "Madikeri",
  "Madhyamgram 2",
  "Madhavpur CC",
  "Madhavadhara Vizag - AP",
  "Maddur SKN",
  "Madanapalli",
  "MG Road Tumkur 2",
  "MEI layout Bangalore",
  "MB Road Kolar",
  "MADHURA NAGAR HYDERABAD",
  "Ludhiana Model Town",
  "Lucknow Dry DC-Virtual",
  "Lucknow Cross Dock DC-Virtual",
  "Lingasur - NKN",
  "Lepakshi Road Hindupur AP",
  "Laxmeshwar Batagurki Complex - KA",
  "Lawspet Pondicherry",
  "Ladhewali Road - Jalandhar - PJ",
  "Kushalnagar SKN",
  "Kurukshetra Kessel Mall",
  "Kurnool Road Atmakur - AP",
  "Kuravilangad Kerala",
  "Kurali Distt Mohali-PB",
  "Kuntloor Road Hayathnagar",
  "Kundara -KL",
  "Kumta - KA",
  "Kumarichandha Dark Store Trivandrum - KL",
  "Kukatpally-2 Dark Store Hyderabad - TG",
  "Kukatpally-1 Dark Store Hyderabad - TG",
  "Kudayampadi KL Central",
  "Krishnapura Suratkal - SKN",
  "Krishnanagar Nadia",
  "Krishnagiri",
  "Kottarakkara new KL",
  "Kotkapura",
  "Kothagudam",
  "Korutla",
  "Konni",
  "Kolkata ZO Industry House 7th Floor",
  "Kolkata Sector of Delhi",
  "Kolkata Scrap Sale",
  "Kolkata RPC Sreerampur - WB",
  "Kolkata RPC Processing Centre Sreerampur - WB",
  "Kolkata Project DC Dankuni - WB",
  "Kolkata FnV packaging centre",
  "Kolkata F&V DC Dankuni - WB",
  "Kolkata Dry DC Dankuni - WB",
  "Kolkata Amazon UCC2 Taratala",
  "Kolkata Amazon UCC1 Tangra",
  "Kolar 2",
  "Kharar Dark Store PJ",
  "Kharagpur",
  "Khanna",
  "Kayarambedu",
  "Kaupu Mangalore",
  "Katwa Purba Bardhaman",
  "Kattanam South KL",
  "Kattamanchi Revenue Ward - AP",
  "Kasturinagar",
  "Kasapuram Road Guntakal - AP",
  "Karwar-Kajubag-NKN",
  "Karukku Korattur Chennai - TN",
  "Karukachal",
  "Karimpur - WB",
  "Kapurthala",
  "Kanuru",
  "Kanjirappally",
  "Kanijanahalli Gate Chickballapura F&V CC",
  "Kangarappadi",
  "Kanchipuram FOTO Fast - TN",
  "Kaman Circle Karim Nagar",
  "Kalyanagar Dharwad Dark Store - KA",
  "Kalna",
  "Kaikamba Mangalore - SKN",
  "Kaikaluru",
  "Kadur - SKN",
  "Kadugodi Dark Store - KA",
  "Kadiri AP",
  "KUVEMPU NAGAR Mysore",
  "KR Nagar Mysore",
  "KN Bangalore Sahakar nagar HM",
  "KN Bangalore Madiwala HM",
  "KD Complex- Zira - PJ",
  "K R Pet SKN",
  "Jpnagar Mysore",
  "Jothisamy Street Tiruttani - TN",
  "Jiaganj - WB",
  "Jhapatapur Kharagpur WB",
  "Jangareddygudem",
  "Jangaon",
  "Janagon Warangal Road",
  "Jalandhar",
  "Jalanagar Bijapur",
  "Jal Vayu Vihar Hyderabad",
  "Jains Alpine Meadows",
  "Jail Road Gurdaspur PB",
  "Jaggaiahpet",
  "Jadcherla",
  "JP Nagar Dark Store Bangalore - KA",
  "Islampur Dark Store Gurgaon - HR",
  "Irinjalakuda KL",
  "Infosys Gachibowli Hyderabad - TG",
  "Infosys Campus Bangalore KA",
  "Indi NKN",
  "Ichapur",
  "IS Rae Bareli Road Lucknow HM - UP",
  "IS Jharsuguda HM - Odisha",
  "IS Gorakhpur HM - UP",
  "ILAKAL NKN",
  "Hyderabad ZO",
  "Hyderabad Sector of Bangalore",
  "Hyderabad Scrap Sale",
  "Hyderabad MRL F&V DC",
  "Hyderabad MHM Circle Office",
  "Hyderabad FNV DC (VL Amazon UHY5 Ramanthapur) - TG",
  "Hyderabad FNV DC (VL Amazon UHY4 Vattinagupally)",
  "Hyderabad F&V DC Devaryamjal Village - TG",
  "Hyderabad Dry DC",
  "Huvinahadagali - NKN",
  "Hubli Tarihal F&V DC",
  "Hubli Sector of Bangalore",
  "Hubli Scrap Sale",
  "Hubli F&V Cold Storage (ECOZEN)",
  "Hubli Dry DC",
  "Hosur Road Dark Store - KA",
  "Hoshiarpur Road Phagwara PB",
  "Hoshiarpur Mall Road",
  "Hoshiarpur Gogia Sons Complex",
  "Hoshiarpur College Road",
  "Hosakerehalli",
  "Hosadurga",
  "Hormavu Bangalore",
  "Honnavara Vasudev Business Park - KA",
  "Holenarasipura",
  "Holalkere Road Chitradurga",
  "Hitech Colony Mancherial - TG",
  "Hiriyur",
  "Hinori Chownk Ladwa HR",
  "Hindupur Road Gorantila - AP",
  "Hindupur",
  "Hebbal Mysore",
  "Hassan F&V CC",
  "Hassan 2",
  "Hassan",
  "Haroa - WB",
  "Haridwar-1 Dark Store - UK",
  "Halisahar",
  "Habra East New",
  "HR Karnal Nirmal Kutia HM",
  "Gyan Khand Indirapuram",
  "Gurugram ZO",
  "Guru Gobind Singh Nagar Jalandhar",
  "Gurgaon Sector 56 HUDA Market",
  "Gurgaon Sector 47 Ava Court",
  "Guntakal",
  "Gulbarga-Old Jevargi road",
  "Gulbarga -Sedam Road - NKN",
  "Gudiyatham",
  "Greater Noida Dark Store - UP",
  "Govind Nagar Dark Store Kanpur - UP",
  "Gothami Nagar Godavarikhani - TG",
  "Gorabazar Behrampore",
  "Gorabazaar",
  "Gopalan Grand Mall Bakery Butcher Production",
  "Gooty AP",
  "Gonikoppa",
  "Gohana Road Sonipat-1 Dark Store - HR",
  "Godrej United - KA",
  "Godavarikhani Peddapally - TG",
  "Ghoshpara Road Shyamnagar Kolkata",
  "Gazipur Dark Store Delhi - DL",
  "Gayathri Nagar Hyderabad",
  "Garhshankar",
  "Garh Road Meerut-1 Dark Store - UP",
  "Gangavathi Neelakanteshwara Colony - KA",
  "Ganga Green Uttarpara",
  "Ganeshpur Road Belgaum",
  "Gandhinagar Anakapally AP",
  "Gandhi Nagar Katpadi - TN",
  "Gajwel - TG",
  "Gajularamaram - TG",
  "Gadag KC Rani Rd",
  "GZB Vijay Nagar",
  "GZB Vasundhara Sector 3",
  "GZB Vasundhara Sector 15",
  "GZB Shastri Nagar",
  "GZB Sector 10 RDC",
  "GZB Rakesh Marg",
  "GZB Rajendra Nagar",
  "GZB Kaushambi",
  "GZB Indirapuram Mahaluxmi Square",
  "GZB Indirapuram Ahinda Khand 2",
  "GZB Gaur Valerio Ahinsa Khand Indrapuram",
  "GZB Crossings Republik",
  "GT Road Panipat Dark Store - HR",
  "GM DC",
  "Furniture DC Bangalore virtual",
  "Freedom Park Vinobanagar - KA",
  "Frazer Town 1st Floor",
  "Format HO",
  "FnV Centre Punjab",
  "FnV Centre Pune",
  "Ferozpur",
  "Fatehgarh Sahib Project DC - PJ",
  "Fatehgarh Sahib Dry DC - PJ",
  "Faridkot",
  "Faridabad Sector 7 HUDA Market",
  "Faridabad Sector 49 Sainik Colony",
  "Faridabad Sector 35 Ashoka Enclave",
  "Faridabad Sector 21 C",
  "Faridabad Sector 15 HUDA Market",
  "FRESHALICIOUS SUPERBAZAAR PVT LTD FTH VIRTUAL",
  "FNV Packaging Unit Bangalore",
  "Erramanzil HM Bakery Butchery Production",
  "Erattupetta Kerala",
  "Elsa Plaza - Godrej AzureTN",
  "Elephant Circle",
  "EPICAH 2 Mayapuri Dark Store Delhi - DL",
  "Duttapukur East",
  "Durgapur Dark Store - WB",
  "Dry DC Punjab New",
  "Dr. Rajkumar Road Mysore",
  "Doraha Punjab",
  "Domlur Dark Store - KA",
  "Domkal - WB",
  "Domjur Afreen Tower - WB",
  "Doddajala Commissary Bangalore",
  "Dhuri Road Sangrur",
  "Dhullapally Commissary Secunderabad",
  "Dhone",
  "Dholkot Ambala-1 Dark Store - HR",
  "Dharampur",
  "Desai Circle Jamkhandi",
  "Delhi Zonal Office",
  "Delhi Scrap Sale",
  "Delhi Mukherjee Park",
  "Delhi Hari Nagar",
  "Delhi Dry DC",
  "Davangere Jayanagar",
  "Davangere -BIET ROAD NKN",
  "Daultabad Dark Store Gurgaon - HR",
  "Dattagalli Mysore",
  "Dasuya - PJ",
  "Dark store Gachibowli",
  "Darbaripur Dark Store Gurugram - HR",
  "Dankuni East",
  "Dankuni Dry DC Kolkata IS - WB",
  "Dandeli-JN Road",
  "DUVVADA ROAD VIZAG",
  "DODDABALLAPURA F&V CC",
  "DL Delhi Rohini HM",
  "Corporate Office Brigade South Parade-Blr - KA_SM",
  "Corporate Office Brigade South Parade-Blr - KA_HO",
  "Corporate Office Brigade South Parade-Blr - KA_HM",
  "Collector Office Junction聽Vizianagaram聽- AP",
  "Cold Storage Cochin-virtual",
  "Cochin Sector of Bangalore",
  "Cochin Scrap Sale",
  "Cochin F&V Cold Storage (Snowman)",
  "Cochin Dry DC",
  "Civil Hospital Road Kharar",
  "Chittaranjan UC - WB",
  "Chitradurga JCR Extn - KA",
  "Chirala",
  "Chinthamani New FNV CC",
  "Chinsurah Hooghly",
  "Chinsurah Dark Store -WB",
  "Chingavanam Kerala",
  "Chilimbi-2 SKN",
  "Chilakaluripet",
  "Chikmagalur",
  "Chikkalsandra Bengaluru",
  "Chennai ZO",
  "Chennai Sector of Bangalore",
  "Chennai Scrap Sale",
  "Chennai FnV packaging centre",
  "Chennai F&V Cold Storage (Snowman)",
  "Chennai Dry DC IS - TN",
  "Chennai Dry DC",
  "Chennai Amazon UMA7 Virugambakkam Chennai - TN",
  "Chennai Amazon UMA2 Tambaram",
  "Chennai (Thiruvallur) Capex DC - TN",
  "Chengannur New",
  "Chengalpattu B",
  "Chandrayangutta Dark Store Hyderabad - TG",
  "Chandigarh Sector 37",
  "Chandigarh Mohali Phase 11",
  "Chandigarh Kharar Sunny Enclave",
  "Chandigarh Infosys Campus",
  "Chamundipuram Mysore",
  "Chakdah",
  "COCHIN FNV DC PACKHOUSE",
  "CHINTAMANI",
  "CC2 NEWTOWN",
  "CC Vantimamidi",
  "CC Shankarapally",
  "CC Narayangaon",
  "CC Hadapsar",
  "CB Road Tadipatri - AP",
  "Butchery SM - Virtual",
  "Burdwan2 WB",
  "Bull Temple Dark Store Bangalore - KA",
  "Bull Temple - Project DC - KA",
  "Brahmavara Crown Mother Palace - KA",
  "Bongaon",
  "Blr Amazon UBL9 Marathalli",
  "Blr Amazon UBL6 Yeshwanthpur",
  "Blr Amazon UBL5 Kengeri",
  "Blr Amazon UBL2 Electronic City",
  "Bikaranakatte MLR",
  "Bhubaneswar Dry DC - OD_virtual",
  "Bhatkal Samanzar KHB Colony - KA",
  "Bhatinda",
  "Bharat Nagar Bangalore",
  "Bhagyanagar Main Road NBS Ongole - AP",
  "Bhadravati",
  "Benachity",
  "Belur Hassan",
  "Belghoria Store",
  "Batala Shastri Nagar",
  "Batala Royal Palace",
  "Basirhat 2 - WB",
  "Basirhat",
  "Basaveswar Nagar Bangalore",
  "Baruipur - WB",
  "Barrackpore Old Calcutta Road",
  "Barrackpore Gen Three",
  "Barewal Road Ludhiana - PB",
  "Barasat 2",
  "Bannerghatta Bangalore Circle Office- SM",
  "Bannerghatta Bangalore Circle Office",
  "Banjara Hills Dark Store Hyderabad TG",
  "Banjara Hills 2 Dark Store Hyderabad TG",
  "Bangalore Scrap Sale",
  "Bangalore RPC (New)",
  "Bangalore Project DC - KA",
  "Bangalore Frozen DC",
  "Bangalore FNV DC FTH VL",
  "Bangalore Dry DC",
  "Bally KolKata - WB",
  "Balajinagar Sangareddy",
  "Bajpe SKN",
  "Baidyabati",
  "Bagula-WB",
  "Bagalur SKN",
  "Baduria - WB",
  "Badkhal Faridabad Dark Store - HR",
  "BSK II Stage",
  "BOLPUR",
  "BELGAUM F & V CC",
  "BDL MIG Colony Hyderabad - TG",
  "BC Road Gajuwaka",
  "BC Road Bantwal",
  "BADVELAndhra",
  "BADAMI-STATION ROADNKN",
  "Athni Road Bijapu",
  "Ashok Nagar Aditya Complex - WB",
  "Asansol- SB Gorai",
  "Asansol Dark Store - WB",
  "Ariadaha",
  "Arcot TN",
  "Arasikere",
  "Arani - TN",
  "Arakkonam",
  "Apparel DC",
  "Apcar Garden Asansol",
  "Annanur",
  "Anjanapura Dark Store Bangalore - KA",
  "Anekal",
  "Anchal New Kerala",
  "Anantpur Kundirpi FNV CC",
  "Ananthnagar E-City Bangalore",
  "Anantapur FNV CC Vadiyampet",
  "Anantapur FNV CC - Garladinne",
  "Ameenpur Hyderabad",
  "Ambegaon F&V CC",
  "Amazon TBC 2",
  "Amazon TBC 1",
  "Amazon TBA 9",
  "Amazon TBA 8",
  "Amazon TBA 7",
  "Amazon TBA 6",
  "Amazon TBA 5",
  "Amazon TBA 4",
  "Amazon TBA 3",
  "Amazon TBA 2",
  "Amazon TBA 1",
  "Alliance Orchid Korattur",
  "Alappuzha New Kerala",
  "Alambazar - Surjo Sen Rd",
  "Ajnala Road - Amritsar Punjab",
  "Airport Gate No.2 - WB",
  "Agarpara",
  "Addanki",
  "Aashiyana Dark Store Lucknow - UP",
  "AVANIGADDA",
  "ANAND NAGAR",
  "A Block Market Ranjit Avenue Punjab",
  "Mysore Vontikoppal",
  "Sangareddy",
  "SM Karukku",
  "SM Samalkota, Kakinada",
  "SM Ladhewali -Jalandhar",
  "Gopalapatnam",
  "SM Gaur Valerio, Gzb",
  "Kurubarahalli Bangalore",
  "College Road- HOSPET",
  "NR Peta - Kurnool",
  "SM Rupnarayanpur (Chittaranjan UP)",
  "Chamundipuram",
  "Kalkere",
  "KN - Area - Vinobha Nagar, Shimoga",
  "Madhavaram",
  "SM Tiruchanur",
  "SHANKER NAGAR",
  "SM Ramdurg",
  "Shahabad, Haryana CC",
  "Madiwala HM Bangalore",
  "R R Nagar 2 Bangalore",
  "Bangalore 1 (KN1)",
  "Garhshankar",
  "RPC Sonipat",
  "Nakodar Road Jalandhar",
  "SM S N Pet, Bellary",
  "Akkayapalem",
  "Sira",
  "Dark Store - Thrikkakara - KL",
  "SM Varthur Road",
  "SM Mundargi",
  "SM Ariadaha",
  "Suri Birbhum",
  "Dark Store - Greater Noida - UP- OCP",
  "TG - Area - Sainikpuri, Hyd North",
  "Vijaywada F&V DC",
  "SM Sector-17-Jagadhari",
  "SM Chikodi Nippani Road",
  "Kotkapura",
  "SM Sector 9- Ambala",
  "Dark Store - Kadugodi - KA",
  "Kanuru",
  "SM Tumkur 3",
  "Station Road Dharwad",
  "Ravulapalem F&V CC",
  "Jadcherla",
  "Jagadhatri Apartment Chandannagar",
  "Mathikere",
  "ADONI NGO COLONY",
  "SM Sec-21, Faridabad",
  "Guru Gobind Singh Nagar Jalandhar",
  "SM Yendada,Vizag",
  "SM K R Pet",
  "SM Vasundhara, Ghaziabad",
  "Karwar",
  "UTTARPARA",
  "HM Gorakhpur",
  "SM Alappuzha",
  "Gadwal",
  "Srinivasas Complex Mancherial",
  "SM Boudha Nagar, Hyderabad",
  "SM Gorabazar",
  "Annanagar West",
  "SM Thalayolaparambu",
  "Ponkunnam",
  "SM Irinjalakkkuda",
  "Pendurthy",
  "SM-Muktsar",
  "Kaman Circle Karim Nagar",
  "SM Attapur, Hyderabad",
  "Chennai ZO",
  "Vijayawada ZO- HO",
  "Sahakarnagar Bangalore HM",
  "Kolkata FnV Packaging Centre",
  "Chikkalsandra Bangalore",
  "Central Plaza Eluru",
  "Apilepalli CC",
  "SM Konni",
  "SM Railwayroad Karnal",
  "SM Bhagyanagar Main Road NBS Ongole - AP",
  "Thuravur Cochin ZO_HO",
  "Sreerampore MHM DC RPC",
  "HM KVR Mall, Ongole - AP",
  "Faridabad Sector 49 Sainik Colony",
  "NawaShahar",
  "MADIKERI",
  "Banjara Hills (Erramanzil) Hyderabad HM",
  "Hosakerehalli Bangalore",
  "Kalpakkam",
  "Jains Alpine Meadows Pallavaram Chennai",
  "SM Vasundhra Sector -13, Gzb",
  "Patiala Urban Estate 1",
  "Malkhed",
  "Vizag F&V DC",
  "Dark Store - Bull Temple - KA",
  "SM Ilkal",
  "Khammam-2",
  "SM Jalalnagar",
  "SM BADAMI-STATION ROAD",
  "Ameenpur Hyderabad",
  "Bangalore Hoskote FnV",
  "Brookefilds Banglore",
  "SM Nakodar, Punjab",
  "Kotturpuram",
  "ASHOKNAGAR",
  "KN - Area - BIET Road, Davangere",
  "KN - Area - Vijay Nagar, Mysore",
  "SM Avanigadda,Vijayawada",
  "SM Annanur",
  "Dark Store - Noida Extension - UP",
  "HM Jharsuguda, Odisha",
  "Sonipat FnV DC Packhouse",
  "Delhi Hari Nagar",
  "Palakonda - AP",
  "SM J P Nagar Hyd, Hyderabad",
  "SM Circuit Road, Hyderabad",
  "Sahara Estate Hyderabad",
  "GZB Rakesh Marg",
  "SM Badvel, Kadapa",
  "KORAMANGALA -2",
  "TN - Area - Madambakkam, Chennai Center",
  "TN - Area - Tiruvannamalai, Rest of TN",
  "Mandya",
  "Dark Store Gazipur Delhi - DL",
  "Metha Nagar",
  "SM Thummalagunta",
  "SM Dankuni",
  "Paruthipara",
  "SM Narsampet",
  "SM Pavagada",
  "SM Tadipatri 2",
  "SM Maddur",
  "Barrackpore Gen-3",
  "SM Hoshiarpur Road Phagwara",
  "Dark Store - Banjara Hills-2 ( Manikonda) - TG",
  "Kolkata MHM Circle Office- Corp HM",
  "Basirhat",
  "Ananthnagar E-City Bangalore",
  "MALLESHPALYA",
  "Anantpur Vadiyampeta F&V CC - AP",
  "SM Vidyanagar Davanagere",
  "NGO Quarters",
  "Dark Store - Sunny Enclave, Kharar",
  "KN - Area - Lingasur, Raichur",
  "Patiala Urban Estate 2",
  "RT Nagar CBI Road Bangalore",
  "SM Infosys Gachibowli Hyderabad - TG",
  "Sodepur Road Madhyamgram Kolkata",
  "SM Shyamnagar",
  "Samkranti Kottayam",
  "SM RDC SEC 10, Ghaziabad",
  "SM Dr. Rajkumar Road",
  "SM Vidyanagar, Kothagudem",
  "Annapureshwari Nagar",
  "Kanteshwar Nizamabad",
  "Boduuppal",
  "Frazer Town 1st Floor",
  "Yelahanka-2",
  "Madhura Nagar Hyderabad",
  "SHYAMNAGAR ROAD",
  "Vellore 3",
  "SM Rajajinagar 2nd BlockSKN",
  "SM - Ashoke Nagar - WB",
  "Beach Road",
  "PJ - Area - Barewal Road, Ludhiana",
  "Hyderabad ZO- HO",
  "Lucknow ZO_HO",
  "Nellore - Maguntilayout",
  "SM T&E, AJC Bose Road",
  "GZB Indirapuram Ahinda Khand 2",
  "DODDABALLAPURA F&V CC",
  "SM Palasa, Vizag",
  "SM Shankar Nagar",
  "Thuravur Cochin F&V",
  "SM Krishnagiri",
  "Bannerghatta Bangalore Circle Office- SM",
  "Chennai ZO- HO",
  "Dark Store - Chandrayangutta",
  "SM Kayarambedu",
  "SM Kuruvilangad",
  "Sec-37 Gurgaon",
  "MB Road Kolar Bangalore",
  "SM Chintamani",
  "DHONE",
  "KN - Area - Bejai, Dakshin Kannada",
  "NARASIPATNAM - VIZAG",
  "SM Barewal Road Ludhiana",
  "SM Sheoraphuli - WB",
  "Ferozpur",
  "Delhi Zonal Office- HO",
  "City Center Durgapur",
  "SM Hamirpur Road Una",
  "SM-Tarikere",
  "KN - BACK END - Mysore",
  "SM Railway Road, Doraha",
  "Ambalamukku-Kerala",
  "Vantimamadi",
  "Pattambi",
  "Jangaon",
  "SM Ranjit Avenue Amritsar",
  "F&V DC Sonipat",
  "PJ - Area - Hoshiarpur",
  "Mankamma Thota Karimnagar",
  "AM-PUN 3- South Central Punjab",
  "Chandigarh Sector 37",
  "Gayathri Nagar Bangalore",
  "GZB Shastri Nagar",
  "Tiruvanamalai Sky Star Plazaa - TN",
  "Salt Lake Kolkata",
  "Dark Store - Hosur Road - KA",
  "SM Ramnagar-BTS",
  "Melvisharam",
  "Thiruvallur",
  "Kolkata ZO (Industry House 7th Floor)",
  "SM Diamond Park, Kolkata",
  "KE - Area - Changanasserry, Greater Alleppey",
  "KN - Area - DHO Circle, Devangere",
  "Hoshiarpur Mall Road",
  "SM TC Palya, Bangalore",
  "SM Siddipet, Hyderabad",
  "SM - Naka Chowrasta Karimnagar - TG",
  "WB - Area - Krishnanagar, WB North",
  "Ranipet",
  "Kuvempunagar Chanapatana",
  "Mysore Hebbal",
  "Hosur HM Bangalore",
  "Prasanth Nagar Trivandrum",
  "Nalagonda",
  "SM Nandyal, Hyderabad",
  "Sempla Sirhind (Chunni) Dry DC",
  "SM Phase 11, Mohali",
  "SM Hassan Kuvempunagara ,Sankaripuram",
  "SM Davangere - Jayanagar",
  "Guntakal",
  "SUKCHAR",
  "SM Mavelikkara",
  "SM Duvvada",
  "Dark Store - Marathalli - KA",
  "SM Jhapetapur Kharagpur",
  "SM Kangarappady",
  "SM Nagamangala",
  "VIJAYANAGAR MYSORE",
  "Chinthamani Madekere Gram F&V CC - KA",
  "SM Mourigram",
  "Sempla Sirhind (Chunni) F&V",
  "Patiala Bhadson Road",
  "SM Sriram Hills Khammam",
  "SM Mandya 2",
  "Ranaghat Nadia",
  "Hyderabad Dry DC",
  "Apcar Garden Asansol",
  "NTPC - Ramagundam",
  "Uralpatti F&V CC",
  "SM Domkal",
  "Ettumanoor Kottayam",
  "SM Pampadi",
  "SM Sreerampore, Hooghly",
  "Korutla",
  "Ramamurthi Nagar",
  "Palta Kolkata",
  "GZB Nipun Mall",
  "GZB Vijay Nagar",
  "SM Habra",
  "Jayanagar",
  "Dark Store - Sarjapura Bangalore - KA",
  "R R Nagar BEML Layout Bangalore",
  "SM Puliyarakonam",
  "Poonamallee Chennai DC",
  "SM Kuntloor",
  "Thiruvannamalai 2 Chennai",
  "SM New Motinagar, Hyderabad",
  "Sunam",
  "TG - Area - Kammam",
  "Corporate Office Brigade South Parade-Blr - KA_HO",
  "Devasandra",
  "Dark Store- Anjanapura Bangalore - KA",
  "Jessore Road, Madhyamgram",
  "Haripad",
  "Hubli Tarihal F&V DC",
  "TC Palya 2 Bangalore",
  "CC2, Newtown Kolkata",
  "Sangrur",
  "SM Pondichery, Airport Rd",
  "SM Gooty",
  "SM Basirhat-2",
  "SM Raichur-Mantralaya Rd",
  "Midnapore",
  "SMKarnamgariThotaKakinada,Vijd",
  "Tippasandra (New) Bangalore",
  "SM Manuguru",
  "SM Santhi Nagar Eluru",
  "Vellore 2",
  "Kadri Temple",
  "Poranki Vijaywada",
  "Kapurthala",
  "SM Domjur Afreen Tower - WB",
  "Gurugram ZO",
  "New Barrackpore",
  "Bobbili",
  "Choolaimedu",
  "SM Toopran, Medak",
  "Durga Apartment Khardah",
  "Chitradurga 2",
  "SM Lepakshi Road Hindupur - AP",
  "Kesavampady",
  "Alliance Orchid Springs Korattur Chennai",
  "SM Puttur 2",
  "KE - Area - Udayamperoor, Greater Ernakulam",
  "SM Mylavaram",
  "SM Srinivas Nagar, Vijayawada",
  "SM Jangareddygudem, Eluru",
  "Meerpet",
  "SM Somawarpet",
  "SM Tilakwadi, Belgaum",
  "Kolkata ZO (Industry House 7th Floor)- HO",
  "SM Anekal",
  "Dark Store - Faridabad 1",
  "Subbanna Garden Vijayanagar Bangalore",
  "SM Parumala - KL",
  "Patiala Sirhind Road",
  "SM, Bally, WB",
  "SM Nungi",
  "SM-Ladwa",
  "Shakuntala Park Behala Kolkata",
  "Jaksons City Centre (Rohini)",
  "ACC Wadi",
  "Corporate Office Brigade South Parade-Blr - KA_SM",
  "Hubli Tarihal Dry DC",
  "KAMAREDDY",
  "Elephant Circle Hyderabad",
  "Rose Apt Hindmotor",
  "SM Airport Gate No.2",
  "SM Arakkonam, Tamil nadu",
  "SM Sengupta Appt, Kolkata",
  "Dark Store - Ghaziabad",
  "Gudiwada",
  "BOLPUR",
  "Dark Store - JP Nagar",
  "SM Agarpara",
  "Chennai FnV Packaging Centre",
  "Haveri",
  "AP - Area - Madhurvada, Vizag",
  "SM Karukachal",
  "SM Upparapalli, Hyderabad",
  "SM Sullia",
  "Vizag_HO",
  "Ganga Green Uttarpara",
  "Vizag ZO",
  "ELLIOT ROAD",
  "Dark Store - Vikas Nagar, Lucknow",
  "SM Janagon -2",
  "SM Bikaranakatte - MLR",
  "Krishnanagar Nadia Kolkata",
  "SM NGO Colony Nizamabad",
  "Narayangaon National F&V CC (Unisol) - MH",
  "Hyderabad ZO",
  "Muralinagar",
  "SM Chilimbi-2",
  "Rajam",
  "Hoskote",
  "SM Raghunathganj",
  "Dark Store - Yelahanka - KA",
  "Mansa",
  "KALNA",
  "Kodigehalli",
  "SM Zaheerabad, Hyderabad",
  "Nabadwip",
  "SM Godrej United",
  "Jaggaiahpet",
  "SM Civil Hospital Road Kharar",
  "Basaveswar Nagar Bangalore",
  "Adambakkam",
  "HM Janta Market Berhampur - OD",
  "Dark Store - Nallakunta - TG",
  "Katwa Purba Bardhaman",
  "KE - Area - Aluva, Rest of Kerela",
  "HM Muzaffar Nagar",
  "SM Vinayaka Nagar, Vizag",
  "SM Netajinagar, Hyderabad",
  "V V Puram Bangalore",
  "Tambaram",
  "Shad Nagar",
  "Vijayawada ZO",
  "Narsaraopeta",
  "Hassan F&V CC",
  "SM Pallom",
  "SM Gurdaspur",
  "Vidya Appartment Parnasree Pally",
  "SM Palasa 2, Vizag",
  "Dark Store - Domlur - KA",
  "Barasat 2 Kolkata",
  "Chilakaluripet",
  "Dark Store - Kukatpally-2 Hyderabad-TG",
  "Wanaparthy",
  "SM Vasundhra Sector -3, Gzb",
  "Rajeshwari Nagar - Ranebennur",
  "SM Punganur",
  "SM wadepally, hanamkonda",
  "SM Nallakunta, Hyderabad",
  "Barrckpore",
  "Adoor -Kerala",
  "SM Ajnala Road Amritsar",
  "SM Mittal Road, Moga Punjab",
  "SM Kudayampadi - Central KL",
  "Bull Temple - Bangalore Hypermarket",
  "Disco Palace Mankundu",
  "Bhiragipattada - Tirupathi",
  "Patiala Model Town Bhupindera Road",
  "Benachity",
  "SM Kanchrapara, Kolkata",
  "SM Kaikaluru",
  "Bejur",
  "Hyderabad DC",
  "Gurgaon Sector 56 HUDA Market",
  "SM Halisahar",
  "Noida Office HM- UP_HO",
  "SM Raniganj",
  "Ferozguda",
  "Faridabad Sector 35 Ashoka Enclave",
  "Alike",
  "SM Arunodaya Nagar, Hyderabad",
  "SM Dammaiguda, Hyderabad",
  "MEI layout Bangalore",
  "Batala Shastri Nagar",
  "Dumdum Rd",
  "SM Velencia Gen 3 - KA",
  "SM Bendre Nagar",
  "SM Gudiyatham",
  "SM Krishnapura",
  "SM Mallappally",
  "Omaxe Connaught Place HM Greater Noida",
  "DOMLUR",
  "Infantry Road Bellary",
  "SM Freedom Park Vinobanagarc",
  "Parcus Road Burdwan",
  "Kammanahalli",
  "Bellary",
  "SM Sikaripura",
  "SM Sanivarapupeta, Eluru",
  "SM Kushal Nagar",
  "Ramji Nagar Nellore",
  "KALYANI",
  "Bannerghatta Bangalore Circle Office- HO",
  "WB - Area - Behrampur",
  "Shivaji Junction Tenali",
  "Hyderbad FNV DC Packhouse",
  "Mudigere",
  "B N reddy Nagar",
  "Skyline Icon-Corp SM",
  "Mylapore",
  "Cochin FnV DC Packhouse",
  "Bhadravathi",
  "Chickballapur CC",
  "SM CHINSURAH",
  "Ushodaya Junction Vizag",
  "SM Sagara-BH Road",
  "Gurgaon Sector 47 Ava Court",
  "VEDAYAPALEM",
  "SM Arasikere",
  "CIT NAGAR",
  "Mungamur Road",
  "SIRUR PARK",
  "Dattagalli Mysore",
  "AKJ Complex Athani Road Vijapura",
  "SM Eerattupetta",
  "SM Hosadurga",
  "Poonamallee Chennai F&V",
  "Vizag Dry DC",
  "Thuravur Cochin DC",
  "Dark Store - EPICAH 2 Mayapuri Delhi - DL",
  "Jalandhar",
  "Phagwara",
  "Bannerghatta Bangalore Circle Office- HM",
  "SM-Qadian",
  "SM Muttuchira - Central KL",
  "Mahadevpura HM",
  "SM Puttaparthi, Ananthapur",
  "SM Kottarakkara",
  "SM Dutt Island, Vizag",
  "Faridkot",
  "SM Katpadi",
  "SM Vijaya Mall Thiruvannamalai",
  "SM Anand Nagar",
  "TG - Area - Sircilla, TG North",
  "Swapna Neer Konnagar",
  "KURNOOL - MADHAVA NAGAR",
  "WB - Area - Bankura-Purulia",
  "SM Old Jevargi Road- Gulbarga",
  "SHANKARAMATHAM",
  "SM Mullanpur",
  "SM Bajpe-Mangalore",
  "Pachalam",
  "CIL Layout",
  "SM Icchapur",
  "SM Sircilla",
  "GZB Indirapuram Mahaluxmi Square",
  "SM A S Rao Nagar, Hyderabad",
  "Yemmiganur",
  "Dark Store - Darbaripur Gurgaon",
  "SM Chingavanam",
  "SM - Kasapuram Road Guntakal - AP",
  "SM Puttur, Mangalore",
  "SM Pileru, Chittoor",
  "GIRINAGAR",
  "Dark Store - Kukatpally-1 Hyderabad-TG",
  "Teachers Colony, Anantapur",
  "SM Dandeli - JN Road",
  "PANAMPILLY NAGAR",
  "SM Deralakatte, Mangalore",
  "SM Karimpur",
  "AP - Area - Kadapa NGO Colony",
  "MARUTI NAGAR",
  "Sahara Complex Asansol",
  "TN - Area - Rangarajpuram, Chennai Center",
  "SM Prestige Notting Hill - KA2",
  "Skyline Icon-HM",
  "57 Street Korattur Chennai",
  "Dark Store - Daultabad Gurgaon - HR",
  "SM Prodattur, Prodattur",
  "Tripunithara",
  "Bongaon Kolkata",
  "Dark Store - Najafgarh - DL",
  "Miryalaguda",
  "PJ-Area-Guru Govind Singh Jalandar, North Punjab",
  "SM Palavancha, Vijayawada",
  "Gajuwaka",
  "Tadepalligudem",
  "Sonipat Dry DC",
  "HM Chinsurah",
  "SM Gajularamalayam",
  "Kothagudam",
  "SM Moula Ali, Hyderabad",
  "Sirhind",
  "SM Gadag KC Rani Rd",
  "Nabha College Road",
  "Elamakkara Ernakulam",
  "Corporate Office - Kolkata",
  "R A Puram",
  "SM Maharanipet Krishna Nagar - AP",
  "SM Belur Hassan",
  "SM Madanpalli, Vijayawada",
  "Suryapet",
  "BATAITALA, HOWRAH",
  "Kurumanpalem",
  "SM Arni",
  "PTC Road Anantapur",
  "SM Yapral, Hyderabad",
  "HM Karnal, Haryana",
  "SM Ramapuram Kerala",
  "SM Karwar-Kajubag-NKN",
  "SM Puttur, Chittoor",
  "SM Manjadi Thiruvalla",
  "Pickle Road, Karwar",
  "Thuravur Cochin ZO",
  "NCS Multiplex Vizianagaram",
  "Sagar Nagar Vizag",
  "Faridabad Sector 15 HUDA Market",
  "SM Pathanamthitta 2 Kerala",
  "Madhavadhara Vizag - AP",
  "Dark Store - Saror Nagar-1 - TG",
  "SM Thiruporur",
  "Ultratech Tadipatri",
  "Anakapalli",
  "Infosys",
  "SM Asansol S B Gorai Road",
  "SM Parakode",
  "SM Piravam",
  "Navanagar",
  "SM-Kurali",
  "SM Changanassery, Kerala",
  "SM Miani Road , Dusuya",
  "Huda",
  "SM Tiruttani",
  "Kayamkulam",
  "SM Mudhol",
  "Gayathri Nagar Hyderabad",
  "James Residency Behala",
  "Nrpet- Eluru",
  "T Nagar",
  "Dark Store - Suchitra Pipe Line Road, Hyd",
  "SM Kaikamba",
  "SM BC Road,Vizag",
  "Padavinangady",
  "SM Jind Sectoe 10",
  "Life Style DC HM CK Palya Bangalore",
  "KOLAPUR",
  "SM Sindhanur Raichur",
  "Dark Store - Gachibowli Hyderabad - TG",
  "SM Iyyappa Nagar, Chennai",
  "SM Gothami Nagar Godavarikhani",
  "JP Nagar - 5th Phase",
  "Chittoor",
  "School Road, Birati",
  "SM Malur F&V CC",
  "Olakkur cc",
  "Nowroji Road",
  "Malerkotla, Punjab CC",
  "Kolencherry",
  "SM Duttapukur",
  "SM - Sentrum Mall Krishnagar - WB",
  "SM Thumpamon",
  "Munnekollal Bangalore",
  "SM Saundatti",
  "Kolkata ZO",
  "Chilimbi",
  "SM- Laxmeshwar - KA",
  "Rajarhat Mani Ratnam Complex - Kol",
  "Sahakar Nagar",
  "Prestige Shantiniketan Bangalore",
  "HM Padma Mall Agra",
  "Morinda",
  "SM Nuzvid, Vijayawada",
  "Dark Store - Mysore - KA",
  "SM Sindagi",
  "Hormavu Bangalore",
  "SM Seethaphalmandi, Hyderabad",
  "SM Urban Estate Jalandhar",
  "SM Baidyabati",
  "Solhapur Road",
  "Jones Road",
  "Rajnagar Hubli",
  "SM Lingasur",
  "SM Wipro - KA",
  "SM Amalapuram",
  "SM Parvathipuram, Vizag",
  "SM Gandhi Nagar Anakapalli",
  "Chikmagalur",
  "SM Savalanga Road, Shimoga",
  "SM - Urmar Tanda",
  "Snehapuri PhaseII",
  "SM Harithavanam colony mallampet",
  "HINDUPUR - RS ROAD",
  "HADADI ROAD",
  "Stamer Road Narasapur",
  " Dark Store - Islampur Gurgaon - HR",
  "Murlandurthy",
  "SM KR Nagar Mysore",
  "PJ - BACK END - Mohali",
  "SM Hiriyur",
  "Nijalingappa layout (DavanGere)",
  "SM Vasundhra Sector -12, Gzb",
  "SM Tiruvuru",
  "Noida Office HM- Corp HM",
  "HM Pressman, Kolkata",
  "SM Debi Service Station HPCL KOLKATA - WB",
  "Odisha ZO",
  "Kaup",
  "SM Rishi Apartment- Behala",
  "Faridabad Sector 7 HUDA Market",
  "Kanithi Road - Gajuwaka 2",
  "SM Hospet-Bellary Road",
  "Rangarajpuram",
  "Dark Store Chinsurah -WB",
  "Madhurvada",
  "AP - Area - Akkayapalem, Vizag",
  "New Mangalore F&V DC - KA",
  "SM Balachaur",
  "SULLURPET",
  "Mahabub Nagar",
  "SM Habsiguda, Hyderabad",
  "Kadapa, AP (SM Rajiv Park)",
  "SM Jamkhandi Desai Circle",
  "SM Malavalli",
  "Moore Avenue",
  "Bannerghatta Bangalore DC",
  "SM Mahabubbad",
  "Dark Store - Chandigarh - DS2 Mohali",
  "SM Tekkali",
  "Balapur",
  "Ghosh Palace, Budge Budge",
  "SM Vinayak Nagar, Tiptur",
  "Zangra Baguihati Kolkata",
  "SM - Collector office vizianagaram - AP",
  "Holalkere Road Chitradurga",
  "SM Prafulla Kanan",
  "Hulimavu",
  "Perambur",
  "SM Chengalpattu",
  "Dark Store - Sainikpuri",
  "Dark Store - Banjara Hills-1 Hyderabad",
  "FREE SCHOOL STREET",
  "SM Koovappadam, Cochin",
  "Bidadi Bangalore",
  "Patiala YPS Road",
  "SAPTHAPUR",
  "Delhi Zonal Office",
  "SM RAJARHAT",
  "Thodupuzha",
  "HM Balasore, Odisha",
  "Barkatpura",
  "Vidhya Giri (Dharwad)",
  "SM Bagula-2",
  "Gadag",
  "JAFFERKHAN COLONY",
  "SM Indi",
  "SM Pulivendula",
  "Chandigarh Kharar Sunny Enclave",
  "Shankarpalle CC",
  "Hubli ZO",
  "Dark Store - Kanpur",
  "Madhavpur",
  "SM KD Complex- Zira",
  "SM Pandalam",
  "GONIKOPPA",
  "AP - BACK END - Tirupati",
  "Dark Store Rama Road - DL",
  "NEW P&T COLONY",
  "Tubinkere CC",
  "Manganam Kurisu Jn Kottayam",
  "Kadapa, AP (SM NGO Colony)",
  "Bannerghatta Bangalore F&V",
  "SM Kumta - KA",
  "BARASAT",
  "Bannerghatta Bangalore RPC",
  "Rajahmundry, AP (SM R V Nagar)",
  "AP - Area - Kanuru, Vijaywada",
  "Aashiyana Dark Store Lucknow - UP",
  "Marappalam-Cochin",
  "Virajpet Kodagu",
  "SM - Bhrahmavara",
  "SM Edappal",
  "Gandhinagar",
  "HM Rajarhat Kolkata",
  "Vijayawada DC",
  "PONDY-2",
  "SM Hitech City Colony, Mancherial",
  "SM Holenarasipura",
  "Bharat Nagar Bangalore",
  "Mannarkkad",
  "Saroornagar HM",
  "TN - Area - Arcot, TN North",
  "MR Palli -Tirupathi",
  "SM Pallickathodu",
  "Hyd Kompally F&V DC",
  "Kakkanad",
  "SM BDL MIG Colony, Hyderabad",
  "Rajappa Nagar High court colony Hyderaba",
  "SM Mollargate",
  "North Paravoor",
  "Bhashyam Circle",
  "Station Road- Tandur",
  "SM Jayamahal Store, Bangalore",
  "SM-Sec 126, Kharar",
  "SM Jal Vayu Vihar,HYD",
  "Dark Store - New Arya Nagar - UP",
  "SM Sakaleshpura",
  "Corporate Office Brigade South Parade-Blr - KA_HM",
  "DHO - Dharwad",
  "Balaya Sastri Layout",
  "Aluva",
  "SM Sodepur, Kolkata",
  "Bendoor",
  "SM Rayachoti",
  "Khammam",
  "SM Kamalanagar ECIL, Hyderabad",
  "KN - Area - Kaggadapur, Bangalore East",
  "SM Udayamperoor",
  "Vennala-Cochin",
  "Belghoria Kolkata",
  "Dark Store - OMR Bangalore - KA",
  "SM Sonarpur",
  "TAMBARAM WEST",
  "Pande",
  "Vignana Nagar Bangalore",
  "Skyline Icon-HO",
  "Saidabad",
  "Kasturi Nagar OMBR Layout Bangalore",
  "Kolkata ZO - HO",
  "SM B H Road, Tiptur",
  "SM Singapura",
  "SM Malancha",
  "AP - Area - Teachers Colony, Anantapur",
  "SM Sadasivpet",
  "Kanchipuram FOTO Fast - TN",
  "Brindavan Nagar",
  "TG - Area - Mahaboob Nagar",
  "Hoshiarpur College Road",
  "Kapilateertham Road",
  "Bhatinda",
  "Dharampur",
  "SM Padil",
  "Chandigarh Infosys Campus",
  "SM Kanjirappally",
  "SM Kadiri,Ananthapur",
  "JP Nagar - Mysore",
  "Kandukuru",
  "SM Sompeta",
  "Vattiyoorkavu Trivandrum",
  "SM Anchal",
  "SM Baruipur",
  "SM Manarcaud",
  "Ganeshpur Road Belgaum",
  "SM Talikoti",
  "NCR - Area - Malvianagar, Delhi/Gurgaon",
  "Chikkadpally",
  "Lucknow Cross Dock DC",
  "JYOTHI NAGAR",
  "KR Palli -Chittoor",
  "Gopalagouda Extension Shimoga",
  "Madipakkam",
  "Sangola (Mahud Road) F&V CC",
  "HASSAN",
  "Hayathnagar Hyderabad",
  "SM Narayana Pura, Bangalore",
  "Panipat CC",
  "Dry DC Kolkata-Dankuni, Hooghly, WB",
  "PJ - Area - Patiala",
  "SM Alambazar Surjo Sen Road",
  "SM BC Road Bantwal",
  "Kuvempunagar-Mysore",
  "Kurukshetra Kessel Mall",
  "HM Surya Central Mall, Vizag - AP",
  "Nirmal Hyderabad",
  "SM Michaelnagar",
  "KN - Area - Old Jevargi Road, Gulbarga",
  "GOKAK",
  "Gorabazar Behrampore",
  "VIP Road Zirakpur",
  "HSR Layout",
  "Ropar",
  "Gyan Khand Indirapuram Ghaziabad",
  "Dhuri Road Sangrur",
  "SM Midnapore 2",
  "WB - Area - Behala - Area - Kolkata South",
  "SM Huvinahadagli",
  "SM Sathupalli",
  "Chirala",
  "Nagar Karnool",
  "SM - NSR Howrah - WB",
  "SM Rajnagar Ghaziabad",
  "Nalgonda 3",
  "HM Galaxy",
  "Pune Zonal Office- HO",
  "Rajpura",
  "SM Kolar 2",
  "Manipal Udupi",
  "Cuddalore",
  "Tonchikoppal-Mysore",
  "SM Uppinangady",
  "SM Godrej",
  "Dark Store Pressman - WB",
  "HM Railway Store, Muzaffarnagar, UP",
  "ANJUNEYA NAGAR",
  "SM Samana",
  "SM - Gangavathi",
  "SM Addanki",
  "Palamaneru F&V CC",
  "SILVER TOWN",
  "AP - Area - RV Nagar , Vijaywada",
  "FnV Packaging Unit Bangalore",
  "Pune Zonal Office",
  "Krishan Kunjo Apt Bandel Hooghly",
  "Devekere Road - Sirsi",
  "HM Nagole, Hyderabad",
  "SM Gulbarga-Sedam Rd",
  "Khanna",
  "Doddaballapur",
  "Hoshiarpur Gogia Sons Complex",
  "Satyabhavan Haridevpur",
  "Tarnaka",
  "Balajinagar Sangareddy",
  "SM Pathanapuram",
  "SM Davangere -BIET ROAD",
  "SM Kattanam",
  "Tumkur",
  "SM Santhinagar, Hyderabad",
  "Dark Store - Thoraipakkam Chennai",
  "Chandigarh ZO",
  "Vellore",
  "SM Armoor Nizamabad, AP",
  "SM Burdwan 2",
  "GZB Rajendra Nagar",
  "Venkat Nagar, Kakinada",
  "Chandigarh ZO- HO",
  "Anantapur F&V CC - Garladinne",
  "NGO Colony Warangal",
  "SM Jiaganj",
  "Kattamanchi Revenue Ward - AP",
  "Bannerghatta Bangalore Circle Office- HM_HO",
  "Vipul Business Park",
  "BELGAUM F & V CC",
  "Batala Royal Palace",
  "SM Kundara",
  "SIDDARTH LAYOUT",
  "Hessargatta",
  "Banashankari 2nd Stage Bangalore",
  "Airport Road",
  "HM Berhampore",
  "Kottayam",
  "Delhi Mukherjee Park",
  "SM Bagalur-Bangalore",
  "SM Crossing Republik",
  "HM Burdwan",
  "Sinthi Dum Dum",
  "Sm Hassan 3",
  "100 Feet Ring Road Vizianagaram",
  "Kusgle",
  "SM Gajwel",
  "Tumkur 2",
  "Siripuram Colony",
  "Vijaya Bank Layout Bangalore",
  "THIRUVALLA",
  "SM-Raikot",
  "TG - Area - HUDA, Hyd East",
  "SM Model Town, Ludhiana",
  "SM Padubidri",
  "General Hospital Trivandrum",
  "SM Tirupattur",
  "Kurishumoodu Chenganassery",
  "Pathanamthitta",
  "Thrikkakara Ernakulam",
  "Rotary Nagar Khammam",
  "AP- Area - Tirupathi, Vijaywada",
  "Ramchandra Puram",
  "SM Ramaraopet",
  "Thorappakkam",
  "SM Siraguppa",
  "New KD Road Mysore",
  "SM Kadur",
  "SM Nelamangala",
  "SM Nizampet, Hyderabad",
  "SM Thumkunta",
  "Frazer Town",
  "Nabagram",
  "SM Sholinganallur",
  "Hassan 2",
  "Old Airport Road HM Bangalore",
  "SM Harihar, Harihar",
  "F&V DC Kolkata-Dankuni, Hooghly, WB",
  "SM Surathkal",
  "SM Vikarabad",
  "SM Rampurhat",
  "Chakdah Kolkata",
  "SM Santipur",
  "GZB Kaushambi",
  "SM Chengannur Kerala",
  "Niveditha Nagar Ananda Layout Mysore",
  "Dark Store - Saroor Nagar-2 - TG",
  "SM Arcot",
  "Railway New Colony",
  "WB - Area - Michaelnagar, Kolkata Central",
  "Medak",
];
export const officeCountry = ["India"];
export const officeState = [
  "Haryana",
  "Telangana",
  "Tamil Nadu",
  "Maharashtra",
  "Delhi NCR",
  "Chandigarh",
  "Punjab",
  "Odisha",
  "Himachal Pradesh",
  "Orissa",
  "Karnataka",
  "Kerala",
  "Delhi",
  "Uttar Pradesh",
  "West Bengal",
  "Andhra Pradesh",
  "Uttarakhand",
];
export const officeCity = [
  "Eluru",
  "Gokak",
  "Chittoor",
  "Coimbatore",
  "Chengannur",
  "Chitradurga",
  "Faridkot",
  "Doraha",
  "Kharagpur",
  "Chengalpattu",
  "Chintamani",
  "Shimoga",
  "Davanagere",
  "Nellore",
  "Ropar",
  "Samana",
  "Thrissur",
  "Nizamabad",
  "Mansa",
  "Mangalore",
  "Mandya",
  "Puttur",
  "Krishnanagar",
  "Jamkhandi",
  "Yamunanagar",
  "Vizag",
  "Manipal",
  "Palakonda",
  "Thiruvarur",
  "Vijaywada",
  "Gurgaon",
  "Hassan",
  "Trivandrum",
  "Ernakulam",
  "Holenarasipura",
  "Kolkata",
  "Kadapa",
  "Rajpura",
  "Belgaum",
  "Anantapur",
  "Sangareddi",
  "Morinda",
  "Malur",
  "Behrampore",
  "Gangavati",
  "Bangalore",
  "Kanpur",
  "Basirhat",
  "Tiruvannamalai",
  "Aruppukkottai",
  "Gurdaspur",
  "Garhshankar",
  "Faridabad",
  "N.A.",
  "Mysore",
  "Zirakpur",
  "Udupi",
  "Ambala",
  "Anakapally",
  "Moga",
  "Dharwad",
  "Sira",
  "Bardhaman",
  "Visakhapatnam",
  "Dusuya",
  "Balasore",
  "Hooghly",
  "Karnal",
  "Ferozepur",
  "Chikmagalur",
  "Mullanpur",
  "Mumbai",
  "Behrampur",
  "Pune",
  "Sangrur",
  "Khanna",
  "Mohali",
  "Kakinada",
  "Bijapur",
  "Greater Noida",
  "Chandanagar",
  "West Godavari",
  "Midnapore",
  "Channapatna",
  "Shivamogga",
  "Patiala",
  "Tumkur",
  "Kharar",
  "Nabha",
  "Dandeli",
  "Vellore",
  "Asansol",
  "Hubli",
  "Khammam",
  "Kolar",
  "Kapurthala",
  "Kothagudem",
  "Saundatti",
  "Arasikere",
  "24 Parganas (north)",
  "Gazipur",
  "Suratkal",
  "Dehli",
  "Karwar",
  "Wadi",
  "Kottayam",
  "Sirhind",
  "Gurugram",
  "Ludhaina",
  "Chikodi",
  "Somawarpet",
  "Bandel",
  "Baruipur",
  "Karimnagar",
  "Vijayawada",
  "Warangal",
  "Harihara",
  "Kerala",
  "Berhampore",
  "Delhi",
  "Krishnagiri",
  "Muzaffarnagar",
  "Muktsar",
  "Siddipet",
  "Bengaluru",
  "Tiptur",
  "Ludhiana",
  "Pathanamthitta",
  "Purulia",
  "Bhubaneshwar",
  "Agra",
  "Nuzvid",
  "Una",
  "Batala",
  "Baranagar",
  "Mahbubnagar",
  "Ongole",
  "Narasapur",
  "Nakodar",
  "Chennai",
  "Krishna",
  "Nashik",
  "Bhatinda",
  "Telengana",
  "Burdwan",
  "Padubidri",
  "Cochin",
  "Bellary",
  "Noida",
  "Alappuzha",
  "Andra",
  "Sirsi",
  "Hyderabad",
  "Whitefield",
  "Srikakulam",
  "Bangalore",
  "K R Pet",
  "Gulbarga",
  "Vizianagaram",
  "Secunderabad",
  "Amritsar",
  "Kollam",
  "Tirupati",
  "Chikkaballapur",
  "Telangana",
  "Hospet",
  "Vishakhapatnam",
  "Kurukshetra",
  "Lucknow",
  "Rajahmundry",
  "Ghaziabad",
  "Panipat",
  "Kolkata",
  "Haveri",
  "Raichur",
  "Sonipat",
  "Cochin",
  "Gadag",
  "Chandigarh",
  "Dakshina Kannada",
  "Gorakhpur",
  "Davangere",
  "Guntakal",
  "Orissa",
  "Madurantakam",
  "Jind",
  "Howrah",
  "Hoshiarpur",
  "Jalandhar",
  "Pavagada",
  "Hoogly",
  "Phagwara",
  "Haridwar",
];
export const costCenter = [
  "DS Karnataka (621)",
  "HM Odisha (483)",
  "SM Uttar Pradesh (362)",
  "SM Andhra Pradesh (610)",
  "MRL CORP HM (986)",
  "SM Haryana (342)",
  "HM Haryana (343)",
  "DS Telangana (616)",
  "DS West Bengal (565)",
  "HM Bangalore (764)",
  "SM kerala (635)",
  "HM West Bengal (564)",
  "HM Telangana (617)",
  "SM Chandigarh (303)",
  "SM West Bengal (562)",
  "SM Telangana (615)",
  "HM Andhra Pradesh (743_AP)",
  "DS Chandigargh (307)",
  "SM Puducherry (641)",
  "SM Punjab (302)",
  "MRL Head office (982)",
  "SM Karnataka (620)",
  "DS Delhi (325)",
  "HM Uttar Pradesh (363)",
  "DS Haryana (344)",
  "HM Delhi (323)",
  "SM Tamil Nadu (640)",
  "DS Tamil Nadu (647)",
  "DS Uttar Pradesh (364)",
  "HM Karnataka (630)",
  "DS Kerala (636)",
  "SM Himachal Pradesh (311)",
  "HM Andhra Pradesh (743)",
  "SM Maharashtra (122)",
  "SM Delhi (322)",
  "DS Andhra Pradesh (611)",
  "DS Punjab (306)",
  "DS & HM Uttarakhand (355)",
  "SM Jharkhand (542)",
  "DS & HM Jharkhand (543)",
];
export const workAreaCode = [
  "0000012",
  "0000016",
  "0000017",
  "0000028",
  "0000031",
  "0000032",
  "0000033",
  "0000034",
  "0000044",
  "0000045",
  "0000053",
  "0000056",
  "0000071",
  "0000074",
  "0000077",
  "0000083",
  "0000084",
  "0000097",
  "0000099",
  "0000200",
  "0000203",
  "0000209",
  "0000210",
  "0000214",
  "0000221",
  "0000236",
  "0000250",
  "0000253",
  "0000257",
  "0000258",
  "0000303",
  "0000304",
  "0000330",
  "0000332",
  "0000333",
  "0000338",
  "0000345",
  "0000346",
  "0000349",
  "0000363",
  "0000409",
  "0000410",
  "0000430",
  "0000431",
  "0000447",
  "0000563",
  "0000662",
  "0000763",
  "0000767",
  "0000796",
  "0000797",
  "0000806",
  "0000809",
  "0000810",
  "0000814",
  "0000819",
  "0000820",
  "0000823",
  "0000824",
  "0000825",
  "0000827",
  "0000828",
  "0000832",
  "0000833",
  "0000835",
  "0000836",
  "0000837",
  "0000843",
  "0000851",
  "0000852",
  "0000853",
  "0000855",
  "0000856",
  "0000858",
  "0000859",
  "0000860",
  "0000862",
  "0000863",
  "0010077",
  "0010101",
  "0010125",
  "0010128",
  "0010130",
  "0010131",
  "0010141",
  "0010142",
  "0010143",
  "0011517",
  "0011540",
  "0011551",
  "0011553",
  "0011554",
  "0011557",
  "0011568",
  "0011569",
  "0011570",
  "0011572",
  "0011573",
  "0011574",
  "0011575",
  "0011577",
  "0011590",
  "0011592",
  "0011593",
  "0011594",
  "0011600",
  "0011602",
  "0011603",
  "0011604",
  "0011605",
  "0011606",
  "0011607",
  "0011608",
  "0011609",
  "0011610",
  "0011611",
  "0011620",
  "0011621",
  "0011622",
  "0011623",
  "0011624",
  "0011625",
  "0011626",
  "0011679",
  "0011680",
  "0011681",
  "0011682",
  "0011683",
  "0011684",
  "0011685",
  "0011686",
  "0011688",
  "0011693",
  "0011696",
  "0011698",
  "0011700",
  "0011701",
  "0011702",
  "0011703",
  "0011704",
  "0011705",
  "0011706",
  "0011707",
  "0011708",
  "0011709",
  "0017102",
  "0017103",
  "0017104",
  "0017105",
  "0017106",
  "0017107",
  "0017108",
  "0020021",
  "0020024",
  "0020032",
  "0020032_HM",
  "0020032_HO",
  "0020032_SM",
  "0032201",
  "0032202",
  "0033101",
  "0034201",
  "0034202",
  "1010100",
  "1010100_HO",
  "1010100-SM-HO",
  "1010100-SM-HO",
  "1010101",
  "1011003",
  "1011006",
  "1011011",
  "1011015",
  "1011019",
  "1011025",
  "1011029",
  "1011031",
  "1011032",
  "1011035",
  "1011037",
  "1011040",
  "1011043",
  "1011060",
  "1011061",
  "1011062",
  "1011064",
  "1011070",
  "1011071",
  "1011081",
  "1011083",
  "1011084",
  "1011330",
  "1011342",
  "1011580",
  "1011905",
  "1011928",
  "1011929",
  "1011933",
  "1011960",
  "1011964",
  "1011983",
  "1011990",
  "1012019",
  "1012020",
  "1012047",
  "1012048",
  "1012087",
  "1012935",
  "1013009",
  "1013019",
  "1013035",
  "1013065",
  "1013071",
  "1013075",
  "1013077",
  "1013108",
  "1013120",
  "1013121",
  "1013122",
  "1013133",
  "1013139",
  "1013172",
  "1013196",
  "1013208",
  "1013210",
  "1013227",
  "1013230",
  "1013256",
  "1013276",
  "1013278",
  "1013298",
  "1013299",
  "1013321",
  "1013330",
  "1013341",
  "1013381",
  "1013396",
  "1013403",
  "1013415",
  "1013417",
  "1013423",
  "1013428",
  "1013449",
  "1013487",
  "1013586",
  "1013677",
  "1013743",
  "1013744",
  "1013786",
  "1013853",
  "1013854",
  "1013866",
  "1013927",
  "1013964",
  "1013978",
  "1013980",
  "1014047",
  "1014051",
  "1014057",
  "1014075",
  "1014077",
  "1014078",
  "1014079",
  "1014092",
  "1014093",
  "1014095",
  "1014116",
  "1014128",
  "1014137",
  "1014138",
  "1014142",
  "1014179",
  "1021087",
  "1023251",
  "1023279",
  "1023700",
  "1023864",
  "1023874",
  "1023977",
  "1031581",
  "1031947",
  "1033158",
  "1033337",
  "1033629",
  "1041354",
  "1041355",
  "1043280",
  "1043936",
  "1043947",
  "1063141",
  "1063937",
  "1073157",
  "1131264",
  "1143223",
  "1150100",
  "1150100_HO",
  "1151591",
  "1151963",
  "1152095",
  "1153132",
  "1153286",
  "1153292",
  "1153352",
  "1153373",
  "1153402",
  "1153437",
  "1153473",
  "1153791",
  "1153872",
  "1153935",
  "1154045",
  "1154180",
  "1161604",
  "1162083",
  "1163334",
  "1170100_HO",
  "1191278",
  "1193022",
  "1193400",
  "1193427",
  "1202010",
  "1203465",
  "1204096",
  "1211280",
  "1211588",
  "1213262",
  "1221273",
  "1223104",
  "1223648",
  "1223893",
  "1223913",
  "1231283",
  "1241284",
  "1243637",
  "1251285",
  "1253349",
  "1253745",
  "1253765",
  "1253865",
  "1261286",
  "1261353",
  "1271356",
  "1271357",
  "1272009",
  "1273793",
  "1273873",
  "1273932",
  "1351307",
  "1351308",
  "1351309",
  "1351311",
  "1351313",
  "1351316",
  "1351317",
  "1351318",
  "1351320",
  "1351321",
  "1351323",
  "1351324",
  "1351343",
  "1351589",
  "1351597",
  "1351608",
  "1351691",
  "1351927",
  "1351962",
  "1353109",
  "1353333",
  "1353347",
  "1353385",
  "1353413",
  "1353501",
  "1353514",
  "1353598",
  "1353961",
  "1353962",
  "1354118",
  "1354119",
  "1354130",
  "1354131",
  "1354132",
  "1354135",
  "1354146",
  "1354149",
  "1354150",
  "1354154",
  "1361325",
  "1364087",
  "1371326",
  "1372039",
  "1381328",
  "1391590",
  "1403173",
  "1500100",
  "1500102",
  "1500102_HO",
  "1500102_SM",
  "1500105_HO",
  "1501090",
  "1501091",
  "1501093",
  "1501100",
  "1501108",
  "1501111",
  "1501112",
  "1501116",
  "1501128",
  "1501129",
  "1501134",
  "1501135",
  "1501137",
  "1501139",
  "1501140",
  "1501142",
  "1501143",
  "1501144",
  "1501147",
  "1501578",
  "1501594",
  "1501699",
  "1501700",
  "1501703",
  "1501887",
  "1501953",
  "1502033",
  "1502040",
  "1502046",
  "1503003",
  "1503010",
  "1503013",
  "1503015",
  "1503018",
  "1503037",
  "1503089",
  "1503092",
  "1503093",
  "1503098",
  "1503123",
  "1503168",
  "1503182",
  "1503192",
  "1503195",
  "1503204",
  "1503213",
  "1503220",
  "1503233",
  "1503242",
  "1503248",
  "1503258",
  "1503281",
  "1503282",
  "1503300",
  "1503306",
  "1503307",
  "1503313",
  "1503329",
  "1503344",
  "1503346",
  "1503350",
  "1503397",
  "1503404",
  "1503405",
  "1503412",
  "1503421",
  "1503424",
  "1503461",
  "1503464",
  "1503512",
  "1503513",
  "1503559",
  "1503602",
  "1503699",
  "1503982",
  "1504048",
  "1504053",
  "1504061",
  "1504062",
  "1504065",
  "1504070",
  "1504076",
  "1504081",
  "1504091",
  "1504094",
  "1504100",
  "1504101",
  "1504105",
  "1504121",
  "1504122",
  "1504124",
  "1504125",
  "1504139",
  "1504140",
  "1504151",
  "1504152",
  "1504167",
  "1504168",
  "1504169",
  "1504170",
  "1504171",
  "1504178",
  "1504183",
  "1504186",
  "1511153",
  "1511154",
  "1511155",
  "1511156",
  "1511157",
  "1511158",
  "1511160",
  "1511596",
  "1511702",
  "1512085",
  "1513097",
  "1513155",
  "1513328",
  "1513411",
  "1513517",
  "1513543",
  "1513781",
  "1514023",
  "1522007",
  "1522043",
  "1522050",
  "1522058",
  "1522059",
  "1522075",
  "1523051",
  "1523059",
  "1523060",
  "1523069",
  "1523115",
  "1523305",
  "1523477",
  "1523494",
  "1523497",
  "1523655",
  "1523721",
  "1523899",
  "1523929",
  "1524085",
  "1524086",
  "1693126",
  "1693392",
  "1693631",
  "17",
  "1701247",
  "1701248",
  "1701249",
  "1701250",
  "1701253",
  "1701254",
  "1701256",
  "1701258",
  "1701259",
  "1701930",
  "1701997",
  "1703266",
  "1703324",
  "1703371",
  "1703408",
  "1703409",
  "1703410",
  "1703496",
  "1703511",
  "1703558",
  "1703603",
  "1703632",
  "1703683",
  "1703698",
  "1703722",
  "1703747",
  "1703898",
  "1704020",
  "1704021",
  "1704022",
  "1704046",
  "1704080",
  "1710100_HO",
  "1710200",
  "1711350",
  "1711689",
  "1711690",
  "1711889",
  "1711890",
  "1711939",
  "1711998",
  "1713360",
  "1713379",
  "1713416",
  "1713419",
  "1713525",
  "1713545",
  "1713601",
  "1713622",
  "1713720",
  "1713749",
  "1713750",
  "1713782",
  "1713799",
  "1713822",
  "1721582",
  "1721583",
  "1721585",
  "1723295",
  "1723450",
  "1723510",
  "1723536",
  "1723778",
  "1724012",
  "1731351",
  "1731706",
  "1733557",
  "1733640",
  "1734084",
  "1741352",
  "1741584",
  "1743124",
  "1743641",
  "1751704",
  "1753138",
  "1753374",
  "1753498",
  "1753604",
  "1753779",
  "1754074",
  "1763034",
  "1763701",
  "1763960",
  "1764015",
  "2000100",
  "2000100_HO",
  "2001164",
  "2001166",
  "2001168",
  "2001173",
  "2001176",
  "2001185",
  "2001186",
  "2001187",
  "2001192",
  "2001193",
  "2001199",
  "2001205",
  "2001207",
  "2001212",
  "2001693",
  "2001694",
  "2001698",
  "2001950",
  "2002051",
  "20024_HM",
  "20024_SM",
  "2003000",
  "2003001",
  "2003007",
  "2003152",
  "2003211",
  "2003212",
  "2003451",
  "2003455",
  "2003463",
  "2003468",
  "2003481",
  "2003491",
  "2003534",
  "2003561",
  "2003796",
  "2003803",
  "2003852",
  "2003921",
  "2004050",
  "2004090",
  "2004113",
  "2011697",
  "2013388",
  "2201294",
  "2201302",
  "2203485",
  "2203489",
  "2203560",
  "2203728",
  "2204052",
  "2500101",
  "2500101_HO",
  "2501217",
  "2501221",
  "2501222",
  "2501223",
  "2501224",
  "2501226",
  "2501227",
  "2501228",
  "2501232",
  "2501239",
  "2501336",
  "2501599",
  "2501600",
  "2501990",
  "2502027",
  "2502028",
  "2502056",
  "2502071",
  "2502073",
  "2502074",
  "2503072",
  "2503073",
  "2503087",
  "2503103",
  "2503117",
  "2503154",
  "2503312",
  "2503433",
  "2503438",
  "2503442",
  "2503469",
  "2503470",
  "2503479",
  "2503483",
  "2503484",
  "2503493",
  "2503508",
  "2503509",
  "2503522",
  "2503531",
  "2503532",
  "2503533",
  "2503537",
  "2503547",
  "2503599",
  "2503620",
  "2503635",
  "2503665",
  "2503869",
  "2504009",
  "2504017",
  "2504043",
  "2504102",
  "2504153",
  "2504181",
  "2504182",
  "2513049",
  "2513086",
  "2513112",
  "2513114",
  "2513414",
  "2513519",
  "2513845",
  "2513846",
  "2523482",
  "2533095",
  "2533462",
  "2533538",
  "2533616",
  "2533727",
  "2601241",
  "3210100_HO",
  "5000100",
  "5000100_HO",
  "5001415",
  "5001958",
  "5001974",
  "5004054",
  "5004104",
  "5004114",
  "5004120",
  "5004144",
  "5014110",
  "5110102",
  "5111601",
  "5113153",
  "5113710",
  "5114082",
  "5114109",
  "5114115",
  "5114117",
  "5114164",
  "5114165",
  "5114166",
  "5121385",
  "5121564",
  "5122080",
  "5123191",
  "5123274",
  "5223031",
  "5223615",
  "5223767",
  "5223768",
  "5224010",
  "5224184",
  "5233805",
  "5501459",
  "5501663",
  "5502001",
  "5503614",
  "5503667",
  "5503692",
  "5503856",
  "5513046",
  "5513127",
  "5513582",
  "5513625",
  "5513666",
  "5513931",
  "5521606",
  "5521804",
  "5521806",
  "5523125",
  "5523250",
  "5523284",
  "5523285",
  "5523693",
  "5531655",
  "5533255",
  "5533332",
  "5533730",
  "5541657",
  "5543081",
  "5550100_HO",
  "5550101",
  "5551566",
  "5551951",
  "5551956",
  "5553770",
  "5554067",
  "5554068",
  "5554162",
  "5554163",
  "5563055",
  "5563056",
  "5563067",
  "5563645",
  "5563731",
  "5563876",
  "5571658",
  "5571809",
  "5573063",
  "5573621",
  "5573829",
  "5592090",
  "5593311",
  "5593316",
  "5593695",
  "5593736",
  "5593784",
  "5611824",
  "5613045",
  "5613085",
  "5613644",
  "5613694",
  "5613804",
  "5622094",
  "5623076",
  "5632097",
  "5633113",
  "5643080",
  "5643096",
  "5643296",
  "6501391",
  "6501467",
  "6501949",
  "6501975",
  "6503020",
  "6503023",
  "6503036",
  "6503171",
  "6503186",
  "6503187",
  "6503190",
  "6503198",
  "6503228",
  "6503238",
  "6503239",
  "6503275",
  "6503435_CHM",
  "6503435_HO",
  "6503553",
  "6503686",
  "6503709",
  "6504055",
  "6504083",
  "6504097",
  "6504108",
  "6504160",
  "6504161",
  "6513225",
  "6514066",
  "6533500_HO",
  "6534063",
  "6534064",
  "6554159",
  "8000102_HO",
  "8000103",
  "8000103_HO",
  "8000104_HMHO",
  "8001433",
  "8001451",
  "8001519",
  "8001529",
  "8001569",
  "8001669",
  "8001671",
  "8001674",
  "8001676",
  "8001683",
  "8001710",
  "8001981",
  "8002006",
  "8002054",
  "8002081",
  "8002099",
  "8003050",
  "8003074",
  "8003091",
  "8003102",
  "8003119",
  "8003150",
  "8003160",
  "8003169",
  "8003200",
  "8003206",
  "8003221",
  "8003224",
  "8003231",
  "8003235",
  "8003240",
  "8003241",
  "8003244",
  "8003245",
  "8003249",
  "8003263",
  "8003270",
  "8003271",
  "8003272",
  "8003287",
  "8003319",
  "8003355",
  "8003356",
  "8003363",
  "8003366",
  "8003391",
  "8003393",
  "8003406",
  "8003429",
  "8003440",
  "8003445",
  "8003446",
  "8003467",
  "8003480",
  "8003499",
  "8003503",
  "8003515",
  "8003539",
  "8003540",
  "8003576",
  "8003609",
  "8003610",
  "8003619",
  "8003670",
  "8003713",
  "8003737",
  "8003787",
  "8003788",
  "8003851",
  "8003861",
  "8003877",
  "8003924",
  "8003930",
  "8003949",
  "8003981",
  "8003990",
  "8004059",
  "8004060",
  "8004107",
  "8004111",
  "8004112",
  "8004123",
  "8004127",
  "8004143",
  "8004145",
  "8004147",
  "8004155",
  "8004156",
  "8004174",
  "8004175",
  "8011498",
  "8021571",
  "8021667",
  "8023290",
  "8023618",
  "8023712",
  "8023766",
  "8023823",
  "8031678",
  "8033339",
  "8033643",
  "8033714",
  "8033806",
  "8053064",
  "8053267",
  "8053288",
  "8053340",
  "8053353",
  "8053362",
  "8053383",
  "8053398",
  "8053860",
  "8053955",
  "8054099",
  "8054103",
  "8480100_HO",
];
export const timeZone = [
  "(GMT+05:30) Asia/Kolkata",
  "(UTC+05:30) Asia/Kolkata",
];
export const attendanceShift = [
  "1022-FE (10PM-7:00AM) Full Time - Night Shift (10:00:00 PM-07:00:00 AM)",
  "Facility Security (11 PM to 7 AM) (11:00:00 PM-07:00:00 AM)",
  "1008-DC (12:00PM to 09:00PM) Full Time (12:00:00 PM-09:00:00 PM)",
  "1029-FE (4:30AM-1:30PM) Full Time - Night shift (04:30:00 AM-01:30:00 PM)",
  "1013-FE (9AM-1:30PM) Part Time (09:00:00 AM-01:30:00 PM)",
  "014-FE (08:00:00 AM-11:45:00 PM)",
  "1028-DC (05:00PM to 02:00AM) Full Time - Night Shift (05:00:00 PM-02:00:00 AM)",
  "1002-DC (09:00AM to 06:00PM) Full Time (09:00:00 AM-06:00:00 PM)",
  "1021-FE (4AM-8:30AM) Part Time (04:00:00 AM-08:30:00 AM)",
  "1026-FE (9PM-6:00AM) Full Time - Night Shift (09:00:00 PM-06:00:00 AM)",
  "Facility Office Boy (9:00 AM to 6:00 PM) (09:00:00 AM-06:00:00 PM)",
  "Facility Pantry (7:00 AM to 4:00 PM) (07:00:00 AM-04:00:00 PM)",
  "1020-DC (11:30AM to 08:30PM) Full Time (11:30:00 AM-08:30:00 PM)",
  "1002-FE (6AM-3PM) Full Time (06:00:00 AM-03:00:00 PM)",
  "1017-FE (6PM-10:30PM) Part Time (06:00:00 PM-10:30:00 PM)",
  "1006-FE (10AM-7PM) Full Time (10:00:00 AM-07:00:00 PM)",
  "1007-FE (11AM-8PM) Full Time (11:00:00 AM-08:00:00 PM)",
  "Facility Housekeeping (08:00 AM - 05:00 PM) (08:00:00 AM-05:00:00 PM)",
  "003-FE (06:00:00 AM-10:00:00 PM)",
  "1014-DC (01:30PM to 10:30PM) Full Time (01:30:00 PM-10:30:00 PM)",
  "1003-FE (7AM-4PM) Full Time (07:00:00 AM-04:00:00 PM)",
  "1025-FE (11PM-8:00AM) Full Time - Night Shift (11:00:00 PM-08:00:00 AM)",
  "1009-FE (1PM-10PM) Full Time (01:00:00 PM-10:00:00 PM)",
  "Facility Security (14:00 - 22:00) (02:00:00 PM-10:00:00 PM)",
  "1004-FE (8AM-5PM) Full Time (08:00:00 AM-05:00:00 PM)",
  "1003-DC (01:00PM to 10:00PM) Full Time (01:00:00 PM-10:00:00 PM)",
  "1013-DC (08:30PM to 05:30AM) Night Shift (08:30:00 PM-05:30:00 AM)",
  "1001-FE (5AM-2PM) Full Time (05:00:00 AM-02:00:00 PM)",
  "1005-DC (06:00AM to 03:00PM) Full Time (06:00:00 AM-03:00:00 PM)",
  "1015-FE (4PM-8:30PM) Part Time (04:00:00 PM-08:30:00 PM)",
  "1011-DC (06:00PM to 10:30PM) Part Time (06:00:00 PM-10:30:00 PM)",
  "Brand Promoters Shift (9:30 AM to 6:30 PM) (09:30:00 AM-09:35:00 AM)",
  "1020-FE (3AM-7:30AM) Part Time - Night Shift (03:00:00 AM-07:30:00 AM)",
  "002-FE (04:00:00 AM-08:00:00 PM)",
  "General Shift_FE (09:30:00 AM-06:30:00 PM)",
  "007-FE (06:00:00 AM-10:00:00 PM)",
  "Do not Use 003-FE (06:00:00 AM-10:00:00 PM)",
  "010-FE (08:00:00 AM-11:45:00 PM)",
  "1008-FE (12AM-9PM) Full Time (12:00:00 PM-09:00:00 PM)",
  "Facility Security (22:00 - 06:00) (10:00:00 PM-06:00:00 AM)",
  "1019-DC (10:00PM to 07:00AM) Night Shift (10:00:00 PM-07:00:00 AM)",
  "General Shift_BE (09:30:00 AM-06:30:00 PM)",
  "Facility Pantry (8:00 AM to 5:00 PM) (08:00:00 AM-05:00:00 PM)",
  "1012-DC (10:00AM to 07:00PM) Full Time (10:00:00 AM-07:00:00 PM)",
  "1028-FE (04AM-1:00PM) Full Time - Night shift (04:00:00 AM-01:00:00 PM)",
  "009-FE (08:00:00 AM-11:45:00 PM)",
  "1007-DC (11:00AM to 08:00PM) Full Time (11:00:00 AM-08:00:00 PM)",
  "1005-FE (9AM-6PM) Full Time (09:00:00 AM-06:00:00 PM)",
  "1001-DC (07:00AM to 04:00PM) Full Time (07:00:00 AM-04:00:00 PM)",
  "Facility Supervisor and MST (09:00 AM to 06:00 PM) (09:00:00 AM-06:00:00 PM)",
  "Facility Security (06:00 - 14:00) (06:00:00 AM-02:00:00 PM)",
  "1022-DC (07:00PM to 04:00AM) Night Shift (07:00:00 PM-04:00:00 AM)",
  "Facility Security (3:00 PM to 11 PM) (03:00:00 PM-10:00:00 PM)",
  "Facility Security (7:00 AM to 3:00 PM) (07:00:00 AM-03:00:00 PM)",
  "1006-DC (08:00AM to 05:00PM) Full Time (08:00:00 AM-05:00:00 PM)",
  "1016-FE (5PM-9:30PM) Part Time (05:00:00 PM-09:30:00 PM)",
  "006-FE (04:00:00 AM-08:00:00 PM)",
  "1009-DC (02:00PM to 11:00PM) Full Time (02:00:00 PM-11:00:00 PM)",
  "1027-FE (3AM-12:00PM) Full Time - Night Shift (03:00:00 AM-12:00:00 PM)",
  "1010-FE (2PM-11PM) Full Time (02:00:00 PM-11:00:00 PM)",
  "1017-DC (06:30AM to 03:30PM) Full Time (06:30:00 AM-03:30:00 PM)",
  "1024-FE (11PM-3:30AM) Part Time - Night Shift (11:00:00 PM-03:30:00 AM)",
  "1012-FE (7AM-11:30AM) Part Time (07:00:00 AM-11:30:00 AM)",
  "Facility Housekeeping (09:00 AM - 06:00 PM) (09:00:00 AM-06:00:00 PM)",
  "001-FE (04:00:00 AM-08:00:00 PM)",
  "Facility Pantry (11:00 AM to 8:00 PM) (11:00:00 AM-08:00:00 PM)",
  "1021-DC (07:30PM to 04:30AM) Night Shift (07:30:00 PM-04:30:00 AM)",
  "1028-DC (05:00PM to 02:00AM) Full Time (05:00:00 PM-02:00:00 AM)",
  "1011-FE (6AM-10:30AM) Part Time (06:00:00 AM-10:30:00 AM)",
  "015-FE (04:00:00 AM-08:00:00 PM)",
  "004-FE (08:00:00 AM-11:45:00 PM)",
  "1014-FE (3PM-7:30PM) Part Time (03:00:00 PM-07:30:00 PM)",
  "1018-DC (09:30AM to 06:30PM) Full Time (09:30:00 AM-06:30:00 PM)",
];
export const attendanceWeeklyOff = [
  "Monday",
  "Tuesday",
  "Friday",
  "Wednesday",
  "Saturday",
  "Thursday",
  "Sunday",
  "Saturday and Sunday",
  "Even (2nd,4th) Saturday",
  "2nd & 4th Saturday & All Sundays",
];
export const attendancePolicy = [
  "Brand Promoters Attendance Policy",
  "Attendance Policy R&M",
  "FE Attendance",
  "FE Attendance - Break Shift",
  "BE off Roll Attendance",
  "Admin Facility Attendance",
  "Supply Chain Management",
  "FE Attendance PT",
  "Backend-Attendance",
];
export const plProbationEnable = ["Enable"];

export const biographyFields = {
  anniversary_date: {
    required: false,
    regex: /^\d{4}-\d{2}-\d{2}$/,
  },
  blood_group: {
    required: false,
    regex: /^(A|B|AB|O)[+-]$/,
  },
  date_of_birth: {
    required: true,
    regex: /^\d{4}-\d{2}-\d{2}$/,
  },
  // full_name: {
  //   required: true,
  //   regex: /^(?! )[A-Za-z]+( [A-Za-z]+)*(?<! )$/,
  // },
  fathers_name: {
    required: true,
    regex: /^(?! )[A-Za-z.]+( [A-Za-z.]+)*(?<! )$/,
  },
  first_name: {
    required: true,
    regex: /^[A-Za-z]+$/,
  },
  gender: {
    required: true,
    regex: /^(Male|Female|Other)$/,
  },
  last_name: {
    required: false,
    regex: /^[A-Za-z.]+$/,
  },
  marital_status: {
    required: false,
    regex: /^(?! )[A-Za-z]+(\s+[A-Za-z]+)*(?<! )$/,
  },
  middle_name: {
    required: false,
    regex: /^[A-Za-z]+$/,
  },
  nationality: {
    required: true,
    regex: /^\S.*\S$|^\S$|^$/,
  },
  resume: {
    required: true,
    regex: /^\{.*\}$/,
  },
};

export const sectionWiseFields = {
  resume: {
    resume: {
      regex: /^.*$/,
      required: true,
    },
  },
  biographical: {
    first_name: {
      regex: /^[A-Za-z]+$/,
      required: true,
    },
    middle_name: {
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      required: false,
    },
    last_name: {
      regex: /^[A-Za-z.]+$/,
      required: false,
    },
    fathers_name: {
      regex: /^(?! )[A-Za-z.]+( [A-Za-z.]+)*(?<! )$/,
      required: true,
    },
    gender: {
      regex: /^[A-Za-z]+$/,
      required: true,
    },
    blood_group: {
      regex: /^(A|B|AB|O)[+-]$/,
      required: false,
    },
    date_of_birth: {
      regex: /^\d{4}-\d{2}-\d{2}$/,
      required: true,
    },
    nationality: {
      regex: /^\S.*\S$|^\S$|^$/,
      required: true,
    },
    marital_status: {
      regex: /^(?! )[A-Za-z]+(\s+[A-Za-z]+)*(?<! )$/,
      required: true,
    },
    anniversary_date: {
      regex: /^\d{4}-\d{2}-\d{2}$/,
      required: false,
    },
  },
  contact: {
    personal_mobile_no: {
      regex: /^[0-9]{10}$/,
      required: true,
    },
    office_mobile_no: {
      regex: /^[0-9]{10}$/,
      required: true,
    },
    personal_email_id: {
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      required: true,
    },
    company_email_id: {
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      required: false,
    },
  },
  address: {
    line_1_address: {
      regex: /^\S.*\S$|^\S$/,
      required: true,
    },
    line_2_address: {
      regex: /^\S.*\S$|^\S$/,
      required: true,
    },
    pincode: {
      regex: /^[0-9]{6}$/,
      required: true,
    },
    address_country: {
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      required: true,
    },
    state: {
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      required: true,
    },
    city: {
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      required: true,
    },
  },
  education: {
    university_name: {
      regex: /^\S.*\S$|^\S$/,
      required: false,
    },
    educational_category: {
      regex: /^\S.*\S$|^\S$/,
      required: false,
    },
    education_degree: {
      regex: /^\S.*\S$|^\S$/,
      required: false,
    },
    field_of_specualisation: {
      regex: /^\S.*\S$|^\S$/,
      required: false,
    },
    course_type: {
      regex: /^\S.*\S$|^\S$/,
      required: false,
    },
    gpa: {
      regex: /^\d+(\.\d+)?$/,
      required: false,
    },
    start_date: {
      regex: /^\d{4}-\d{2}-\d{2}$/,
      required: false,
    },
    end_date: {
      regex: /^\d{4}-\d{2}-\d{2}$/,
      required: false,
    },
  },
  work: {
    company_name: {
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      required: false,
    },
    job_title: {
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      required: false,
    },
    job_location: {
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      required: false,
    },
    job_summary: {
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      required: false,
    },
    start_date: {
      regex: /^\d{4}-\d{2}-\d{2}$/,
      required: false,
    },
    end_date: {
      regex: /^\d{4}-\d{2}-\d{2}$/,
      required: false,
    },
    current_check: {
      regex: null,
      required: false,
    },
  },
  personal: {
    aadhaar_number: {
      regex: /^\d{12}$/,
      required: true,
    },
    pan_number: {
      regex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
      required: false,
    },
    dl_number: {
      regex: /^[A-Z]{2}[0-9]{2}\s?[0-9]{11}$|^[A-Z]{2}[0-9]{2}[0-9A-Z]{11}$/,
      required: false,
    },
  },
  salary: {
    name_account: {
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      required: true,
    },
    account_number: {
      regex: /^\d{9,18}$/,
      required: true,
    },
    bank_name: {
      regex: /^\S.*\S$|^\S$/,
      required: true,
    },
    branch_name: {
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      required: true,
    },
    ifsc_code: {
      regex: /^[A-Z]{4}0[A-Z0-9]{6}$/,
      required: true,
    },
    account_type: {
      regex: /^[A-Za-z]+$/,
      required: true,
    },
    esic_number: {
      regex: /^\d{10}$/,
      required: false,
    },
    pf_number: {
      regex: /^[A-Za-z0-9/]+$/,
      required: false,
    },
    tds_applicability: {
      regex: /^(Yes|No)$/,
      required: false,
    },
  },
  social: {
    uan_number: {
      regex: /^\d{12}$/,
      required: false,
      section: "social security",
    },
  },
  documents: {
    profile_picture: {
      regex: /^.*$/,
      required: false,
    },
    aadhaar_front: {
      regex: /^.*$/,
      required: true,
    },
    aadhaar_back: {
      regex: /^.*$/,
      required: true,
    },
    marksheet_10th: {
      regex: /^.*$/,
      required: false,
    },
    marksheet_12th: {
      regex: /^.*$/,
      required: false,
    },
    graduation: {
      regex: /^.*$/,
      required: false,
    },
    salary_slip: {
      regex: /^.*$/,
      required: false,
    },
  },
};

export const createUserSamplePayload = {
  user_details: {
    first_name: null,
    last_name: null,
    middle_name: null,
    date_of_joining: null,
    blood_group: null,
    band: null,
    grade: null,
    division: null,
    designation: null,
    job_level: null,
    // job_level_code: null,
    personal_email_id: null,
    marital_status: null,
    anniversary_date: null,
    time_zone: null,
    work_area_code_x: null,
    contribution_level: null,
    functional_area: null,
    functional_area_code: null,
    functional_area_cost_center: null,
    position_id: null,
    location_type: null,
    city_type: null,
    centre_type: null,
    office_city: null,
    office_state: null,
    office_country: null,
    office_region: null,
    base_office_location: null,
    business_unit: null,
    business_unit_head: null,
    department_code: null,
    departments_hierarchy: null,
    direct_manager_name: null,
    direct_manager_employee_id: null,
    direct_manager_email: null,
    hrbp_employee_id: null,
    hrbp_name: null,
    hrbp_email_id: null,
    group_company: null,
    group_company_code: null,
    gender: null,
    date_of_birth: null,
    employee_id: null,
    employee_type: null,
    employee_status: null,
    employee_sub_type: null,
    employment_type: null,
    cost_center: null,
    personal_mobile_no: null,
    office_mobile_no: null,
    date_of_confirmation: null,
    confirmation_status: null,
    attendance_shift: null,
    attendance_policy: null,
    attendance_weeklyoff: null,
    date_of_resignation: null,
    date_of_exit: null,
    employee_separation_reason: null,
    // full_name: null,
    fathers_name: null,
    // pl_probation_enable: null,
    nationality: null,
    line_1_address: null,
    line_2_address: null,
    city: null,
    state: null,
    address_country: null,
    pincode: null,
    vendor_name: null,
    vendor_emp_id: null,
    bill_amazon: null,
    channel: null,
    workforce_engagement: null,
    education: [
      {
        university_name: null,
        educational_category: null,
        education_degree: null,
        field_of_specualisation: null,
        course_type: null,
        gpa: null,
        start_date: null,
        end_date: null,
      },
    ],
    job_history: [
      {
        company_name: null,
        job_title: null,
        job_location: null,
        job_summary: null,
        start_date: null,
        end_date: null,
        current_check: false,
      },
    ],
    misc: {
      source_of_job_application: null,
      previousEmpCode: null,
      previousEmailID: null,
      more_user_details: null,
    },
  },
  bank_details: {
    account_number: null,
    ifsc_code: null,
    bank_name: null,
    branch_name: null,
    name_account: null,
    account_type: null,
    tds_applicability: null,
    pf_number: null,
    uan_number: null,
    esic_number: null,
  },
  doc_details: {
    aadhaar_number: null,
    pan_number: null,
    dl_number: null,
    resume: null,
    profile_picture: null,
    aadhaar_front: null,
    aadhaar_back: null,
    marksheet_10th: null,
    marksheet_12th: null,
    graduation: null,
    salary_slip: null,
  },
};

export const commonFields = {
  user_details: {
    anniversary_date: {
      required: false,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "biographical",
    },
    blood_group: {
      required: false,
      regex: /^(A|B|AB|O)[+-]$/,
      section: "biographical",
    },
    date_of_birth: {
      required: true,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "biographical",
    },
    fathers_name: {
      required: true,
      regex: /^(?! )[A-Za-z.]+( [A-Za-z.]+)*(?<! )$/,
      section: "biographical",
    },
    first_name: {
      required: true,
      regex: /^[A-Za-z]+$/,
      section: "biographical",
    },
    gender: {
      required: true,
      regex: /^[A-Za-z]+$/,
      section: "biographical",
    },
    last_name: {
      required: false,
      regex: /^[A-Za-z.]+$/,
      section: "biographical",
    },
    marital_status: {
      required: true,
      regex: /^(?! )[A-Za-z]+(\s+[A-Za-z]+)*(?<! )$/,
      section: "biographical",
    },
    middle_name: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "biographical",
    },
    nationality: {
      required: true,
      regex: /^\S.*\S$|^\S$|^$/,
      section: "biographical",
    },
    personal_mobile_no: {
      required: true,
      regex: /^[0-9]{10}$/,
      section: "contact details",
    },
    office_mobile_no: {
      required: true,
      regex: /^[0-9]{10}$/,
      section: "contact details",
    },
    personal_email_id: {
      required: true,
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      section: "contact details",
    },
    company_email_id: {
      required: false,
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      section: "contact details",
    },
    line_1_address: {
      required: true,
      regex: /^\S.*\S$|^\S$/,
      section: "address details",
    },
    line_2_address: {
      required: true,
      regex: /^\S.*\S$|^\S$/,
      section: "address details",
    },
    city: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "address details",
    },
    state: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "address details",
    },
    address_country: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "address details",
    },
    pincode: {
      required: true,
      regex: /^[0-9]{6}$/,
      section: "address details",
    },
    university_name: {
      required: false,
      regex: /^\S.*\S$|^\S$/,
      section: "education details",
    },
    educational_category: {
      required: false,
      regex: /^\S.*\S$|^\S$/,
      section: "education details",
    },
    education_degree: {
      required: false,
      regex: /^\S.*\S$|^\S$/,
      section: "education details",
    },
    field_of_specualisation: {
      required: false,
      regex: /^\S.*\S$|^\S$/,
      section: "education details",
    },
    course_type: {
      required: false,
      regex: /^\S.*\S$|^\S$/,
      section: "education details",
    },
    gpa: {
      required: false,
      regex: /^\d+(\.\d+)?$/,
      section: "education details",
    },
    start_date: {
      required: false,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "education details",
    },
    end_date: {
      required: false,
      regex: /^\\d{4}-\\d{2}-\\d{2}$/,
      section: "education details",
    },
    company_name: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "work experience",
    },
    job_title: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "work experience",
    },
    job_location: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "work experience",
    },
    job_summary: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "work experience",
    },
    salary_slip: {
      required: false,
      regex: /^.*$/,
      section: "documents",
    },
    employee_id: {
      required: true,
      regex: /^[A-Z0-9]+$/,
      section: "job details",
    },
    employee_status: {
      required: true,
      regex: /^[A-Za-z]+$/,
      section: "job details",
    },
    date_of_joining: {
      required: true,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "job details",
    },
    employee_type: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    confirmation_status: {
      required: false,
      regex: /^[A-Za-z]+$/,
      section: "job details",
    },
    date_of_confirmation: {
      required: true,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "job details",
    },
    employee_sub_type: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    employment_type: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    date_of_exit: {
      required: false,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "job details",
    },
    date_of_resignation: {
      required: false,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "job details",
    },
    band: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    grade: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    division: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    designation: {
      required: true,
      // regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    position_id: {
      required: true,
      regex: /^\S.*\S$|^\S$/,
      section: "job details",
    },
    job_level: {
      required: true,
      regex: /^[A-Za-z0-9][A-Za-z0-9\s!@#$%^&*()-_+]*[A-Za-z0-9]$/,
      section: "job details",
    },
    business_unit: {
      required: true,
      regex: /^[A-Za-z0-9][A-Za-z0-9\s!@#$%^&*()\-_'"+]*[A-Za-z0-9]$/,
      section: "job details",
    },
    business_unit_head: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    department_code: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    departments_hierarchy: {
      required: true,
      regex: /^[a-zA-Z0-9\s\W]+$/,
      section: "job details",
    },
    group_company_code: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    base_office_location: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    location_type: {
      required: true,
      // regex: /^\S.*\S$|^\S$/,
      section: "job details",
    },
    office_country: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    office_state: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    office_region: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    office_city: {
      required: true,
      // regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    city_type: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    cost_center: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    centre_type: {
      required: false,
      regex: /^\d+(\.\d+)?$/,
      section: "job details",
    },
    work_area_code_x: {
      required: true,
      regex: /^[a-zA-Z0-9_-]+$/,
      section: "job details",
    },
    direct_manager_name: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    direct_manager_employee_id: {
      required: true,
      regex: /^\d+(\.\d+)?$/,
      section: "job details",
    },
    direct_manager_email: {
      required: true,
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      section: "job details",
    },
    hrbp_name: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    hrbp_employee_id: {
      required: true,
      regex: /^\d+(\.\d+)?$/,
      section: "job details",
    },
    hrbp_email_id: {
      required: true,
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      section: "job details",
    },
    time_zone: {
      required: false,
      regex: /^.*$/,
      section: "job details",
    },
    attendance_shift: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    attendance_policy: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    attendance_weeklyoff: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    contribution_level: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    vendor_name: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    vendor_emp_id: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    bill_amazon: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    channel: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    workforce_engagement: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    functional_area: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    functional_area_cost_center: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    source_of_job_application: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    previousEmpCode: {
      required: false,
      regex: /^\d+(\.\d+)?$/,
      section: "job details",
    },
    previousEmailID: {
      required: false,
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      section: "job details",
    },
    more_user_details: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },

    name_on_driving_license: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    driving_license_issue_date: {
      required: false,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "job details",
    },
  },
  bank_details: {
    name_account: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "salary account details",
    },
    account_number: {
      required: true,
      regex: /^\d{9,18}$/,
      section: "salary account details",
    },
    bank_name: {
      required: true,
      regex: /^\S.*\S$|^\S$/,
      section: "salary account details",
    },
    account_type: {
      required: true,
      regex: /^[A-Za-z]+$/,
      section: "salary account details",
    },
    ifsc_code: {
      required: true,
      regex: /^[A-Z]{4}0[A-Z0-9]{6}$/,
      section: "salary account details",
    },
    branch_name: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "salary account details",
    },
    esic_number: {
      required: false,
      regex: /^\d{10}$/,
      section: "salary account details",
    },
    uan_number: {
      required: false,
      regex: /^\d{12}$/,
      section: "social security",
    },
    pf_number: {
      required: false,
      regex: /^[A-Za-z0-9/]+$/,
      section: "social security",
    },
    tds_applicability: {
      required: false,
      regex: /^(Yes|No)$/,
      section: "social security",
    },
  },
  doc_details: {
    aadhaar_number: {
      required: true,
      regex: /^\d{12}$/,
      section: "personal identity",
    },
    pan_number: {
      required: false,
      regex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
      section: "personal identity",
    },
    dl_number: {
      required: false,
      regex: /^[A-Z]{2}[0-9]{2}\s?[0-9]{11}$|^[A-Z]{2}[0-9]{2}[0-9A-Z]{11}$/,
      section: "personal identity",
    },
    resume: {
      required: true,
      regex: /^.*$/,
      section: "resume",
    },
    profile_picture: {
      required: false,
      regex: /^.*$/,
      section: "documents",
    },
    aadhaar_front: {
      required: true,
      regex: /^.*$/,
      section: "documents",
    },
    aadhaar_back: {
      required: true,
      regex: /^.*$/,
      section: "documents",
    },
    marksheet_10th: {
      required: false,
      regex: /^.*$/,
      section: "documents",
    },
    marksheet_12th: {
      required: false,
      regex: /^.*$/,
      section: "documents",
    },
    graduation: {
      required: false,
      regex: /^.*$/,
      section: "documents",
    },
  },
};

export const commonUpdateFields = {
  user_details: {
    anniversary_date: {
      required: false,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "biographical",
    },
    blood_group: {
      required: false,
      regex: /^(A|B|AB|O)[+-]$/,
      section: "biographical",
    },
    date_of_birth: {
      required: true,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "biographical",
    },
    fathers_name: {
      required: true,
      regex: /^(?! )[A-Za-z.]+( [A-Za-z.]+)*(?<! )$/,
      section: "biographical",
    },
    gender: {
      required: true,
      regex: /^[A-Za-z]+$/,
      section: "biographical",
    },
    marital_status: {
      required: true,
      regex: /^(?! )[A-Za-z]+(\s+[A-Za-z]+)*(?<! )$/,
      section: "biographical",
    },
    nationality: {
      required: true,
      regex: /^\S.*\S$|^\S$|^$/,
      section: "biographical",
    },
    personal_mobile_no: {
      required: true,
      regex: /^[0-9]{10}$/,
      section: "contact details",
    },
    office_mobile_no: {
      required: true,
      regex: /^[0-9]{10}$/,
      section: "contact details",
    },
    personal_email_id: {
      required: true,
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      section: "contact details",
    },
    company_email_id: {
      required: false,
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      section: "contact details",
    },
    university_name: {
      required: false,
      regex: /^\S.*\S$|^\S$/,
      section: "education details",
    },
    educational_category: {
      required: false,
      regex: /^\S.*\S$|^\S$/,
      section: "education details",
    },
    education_degree: {
      required: false,
      regex: /^\S.*\S$|^\S$/,
      section: "education details",
    },
    field_of_specualisation: {
      required: false,
      regex: /^\S.*\S$|^\S$/,
      section: "education details",
    },
    course_type: {
      required: false,
      regex: /^\S.*\S$|^\S$/,
      section: "education details",
    },
    gpa: {
      required: false,
      regex: /^\d+(\.\d+)?$/,
      section: "education details",
    },
    start_date: {
      required: false,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "education details",
    },
    end_date: {
      required: false,
      regex: /^\\d{4}-\\d{2}-\\d{2}$/,
      section: "education details",
    },
    company_name: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "work experience",
    },
    job_title: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "work experience",
    },
    job_location: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "work experience",
    },
    job_summary: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "work experience",
    },
    salary_slip: {
      required: false,
      regex: /^.*$/,
      section: "documents",
    },
    employee_id: {
      required: true,
      regex: /^[A-Z0-9]+$/,
      section: "job details",
    },
    employee_status: {
      required: true,
      regex: /^[A-Za-z]+$/,
      section: "job details",
    },
    date_of_joining: {
      required: true,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "job details",
    },
    employee_type: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    confirmation_status: {
      required: false,
      regex: /^[A-Za-z]+$/,
      section: "job details",
    },
    date_of_confirmation: {
      required: true,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "job details",
    },
    employee_sub_type: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    employment_type: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    date_of_exit: {
      required: false,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "job details",
    },
    date_of_resignation: {
      required: false,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "job details",
    },
    band: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    grade: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    division: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    designation: {
      required: true,
      // regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    position_id: {
      required: true,
      regex: /^\S.*\S$|^\S$/,
      section: "job details",
    },
    job_level: {
      required: true,
      regex: /^[A-Za-z0-9][A-Za-z0-9\s!@#$%^&*()-_+]*[A-Za-z0-9]$/,
      section: "job details",
    },
    business_unit: {
      required: true,
      regex: /^[A-Za-z0-9][A-Za-z0-9\s!@#$%^&*()\-_'"+]*[A-Za-z0-9]$/,
      section: "job details",
    },
    business_unit_head: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    department_code: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    departments_hierarchy: {
      required: true,
      regex: /^[a-zA-Z0-9\s\W]+$/,
      section: "job details",
    },
    group_company_code: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    base_office_location: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    location_type: {
      required: true,
      // regex: /^\S.*\S$|^\S$/,
      section: "job details",
    },
    office_country: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    office_state: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    office_region: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    office_city: {
      required: true,
      // regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    city_type: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    cost_center: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    centre_type: {
      required: false,
      regex: /^\d+(\.\d+)?$/,
      section: "job details",
    },
    work_area_code_x: {
      required: true,
      regex: /^[a-zA-Z0-9_-]+$/,
      section: "job details",
    },
    direct_manager_name: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    direct_manager_employee_id: {
      required: true,
      regex: /^\d+(\.\d+)?$/,
      section: "job details",
    },
    direct_manager_email: {
      required: true,
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      section: "job details",
    },
    hrbp_name: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    hrbp_employee_id: {
      required: true,
      regex: /^\d+(\.\d+)?$/,
      section: "job details",
    },
    hrbp_email_id: {
      required: true,
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      section: "job details",
    },
    time_zone: {
      required: false,
      regex: /^.*$/,
      section: "job details",
    },
    attendance_shift: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    attendance_policy: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    attendance_weeklyoff: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    contribution_level: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    vendor_name: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    vendor_emp_id: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    bill_amazon: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    channel: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    workforce_engagement: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    functional_area: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    functional_area_cost_center: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    source_of_job_application: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    previousEmpCode: {
      required: false,
      regex: /^\d+(\.\d+)?$/,
      section: "job details",
    },
    previousEmailID: {
      required: false,
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      section: "job details",
    },
    more_user_details: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    name_on_driving_license: {
      required: false,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "job details",
    },
    driving_license_issue_date: {
      required: false,
      regex: /^\d{4}-\d{2}-\d{2}$/,
      section: "job details",
    },
  },
  bank_details: {
    name_account: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "salary account details",
    },
    account_number: {
      required: true,
      regex: /^\d{9,18}$/,
      section: "salary account details",
    },
    bank_name: {
      required: true,
      regex: /^\S.*\S$|^\S$/,
      section: "salary account details",
    },
    account_type: {
      required: true,
      regex: /^[A-Za-z]+$/,
      section: "salary account details",
    },
    ifsc_code: {
      required: true,
      regex: /^[A-Z]{4}0[A-Z0-9]{6}$/,
      section: "salary account details",
    },
    branch_name: {
      required: true,
      regex: /^(?! )[A-Za-z0-9\s!@#$%^&*(),.?":{}|<>_'-]+(?<! )$/,
      section: "salary account details",
    },
    esic_number: {
      required: false,
      regex: /^\d{10}$/,
      section: "salary account details",
    },
    uan_number: {
      required: false,
      regex: /^\d{12}$/,
      section: "social security",
    },
  },
};
